import { jsx as a, jsxs as I, Fragment as X } from "react/jsx-runtime";
import { IconButton as Ye, MenuList as ct, Chip as ut, TextField as gt, Table as yt, Button as ae, Popover as br, Checkbox as Ar, Spinner as Ir, ButtonGroup as Nr, Alert as St, Radio as Rt, TextArea as wr, Modal as zt, SnackbarProvider as Or, Menu as Et, MenuItem as Le, Body as Oe, Caption as xe, Divider as Ut, Skeleton as Re, useSnackbar as Lr, SideNavigation as Mr, SideNavigationItem as Pr } from "@walmart-dataventures/shared-components";
import * as mt from "react";
import y, { useState as j, useRef as qt, useEffect as ve, useCallback as Rr, useMemo as Ur } from "react";
import { useLingui as Gr, I18nProvider as Dr } from "@lingui/react";
import xr from "axios";
import * as de from "@livingdesign/icons";
import { Plus as kr, User as Gt, Menu as Hr, ExternalLink as Br, QuestionCircle as Fr, ArrowLeft as Vr, Cart as Tt, Home as Ke } from "@livingdesign/icons";
import { useSnackbar as Wr, IconButton as Yt } from "@walmart-web/livingdesign-components";
import "@walmart-dataventures/shared-components/dist/esm/index.css";
import { useNavigate as Ze } from "react-router-dom";
import { colorCoreBlack as $r } from "@livingdesign/tokens/dist/js/light/mega/globals.js";
function Xe(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function ee(e, t, n, r) {
  function o(s) {
    return s instanceof n ? s : new n(function(i) {
      i(s);
    });
  }
  return new (n || (n = Promise))(function(s, i) {
    function l(g) {
      try {
        m(r.next(g));
      } catch (C) {
        i(C);
      }
    }
    function d(g) {
      try {
        m(r.throw(g));
      } catch (C) {
        i(C);
      }
    }
    function m(g) {
      g.done ? s(g.value) : o(g.value).then(l, d);
    }
    m((r = r.apply(e, t || [])).next());
  });
}
var J;
(function(e) {
  e.ListGroups = "listGroups", e.GroupDetails = "groupDetails", e.CreateGroup = "createGroup";
})(J || (J = {}));
var D;
(function(e) {
  e.GetGroups = "getGroups", e.GetGroupsError = "getGroupsError", e.SetGroups = "setGroups", e.SetFilters = "setFilters", e.SetSelectedGroups = "setSelectedGroups", e.ClearSelectedGroups = "ClearSelectedGroups", e.SetFavouriteGroups = "setFavouriteGroups", e.SetCurrentPage = "setCurrentPage", e.SetSelectedGroup = "setSelectedGroup", e.GetGroup = "getGroup", e.GetGroupError = "getGroupError", e.SetGroup = "setGroup", e.SetCreateGroupInput = "setCreateGroupInput", e.CreateGroup = "createGroup", e.CreateGroupError = "createGroupError", e.CreatedGroup = "createdGroup";
})(D || (D = {}));
var _e;
(function(e) {
  e.NewGroupButtonClicked = "newGroupButtonClicked", e.NewGroupCreationSubmitted = "newGroupCreationSubmitted", e.GroupsSelectionApplied = "groupsSelectionApplied";
})(_e || (_e = {}));
var K;
(function(e) {
  e.FileInput = "fileUpload", e.TextInput = "textInput";
})(K || (K = {}));
const Dt = {
  "Group Name": "GROUP_NAME",
  UPC: "ID",
  Creator: "CREATOR",
  Path: "PATH"
}, xt = {
  All: "ALL",
  Scintilla: "SCINTILLA",
  "Shopper Behavior": "SHOPPER_BEHAVIOR"
}, kt = {
  All: "ALL",
  "Created by me": "CREATED_BY_ME",
  Selected: "SELECTED"
}, jr = {
  MULTIPLE_TENANTS: "MULTIPLE_TENANTS"
}, Kt = 200 * 1024, z = {
  NOT_AUTHORIZED: "You are not authorized or session has been expired. Please try again.",
  NO_DATA_AVAILABLE: "No data available.",
  DEFAULT_ERROR_MESSAGE: "There seems to be a problem, please retry after sometime.",
  ACCESS_DENIED: "Access Denied/Forbidden.",
  FAILED_TO_FETCH_DATA: "Failed to fetch the data",
  METHOD_NOT_ALLOWED: "",
  MAX_SELECTION_LIMIT: "You have reached the selection limit",
  textInputPlaceholder: "Enter group values here and separate them by comma",
  noValidUPCItems: "Your input contains invalid IDs. Please correct them then try again. ",
  partialValidUPCItems1: "Your file contains 1 invalid ID.",
  partialValidUPCItemsSuffix: "You can still create a group with the remaining valid IDs. The invalid ones will be removed automatically:",
  dragAndDropHere: "Drag and drop file here",
  dragAndDropSubText: "Format accepted: .xlsx | Row max: 10,000 | File size max: 200KB | 1 file only",
  fileExceedsLimit: "File exceeds limit of 200KB",
  unsupportedFileType: "Unsupported file type",
  enterTextInput: "Enter group UPC values here and seperate them by comma",
  groupName: "Enter group name",
  description: "Enter description",
  nameRequired: "Name is required.",
  nameMinLength: "Group name should be at least five characters long.",
  addFavouriteFailed: "Cannot add to starred, please try again later",
  removeFavouriteFailed: "Cannot remove from starred, please try again later"
};
var ft = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Zt = {}, Xt = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.errorMessages = e.ErrorType = void 0;
  var t;
  (function(n) {
    n.MalformedUnicode = "MALFORMED_UNICODE", n.MalformedHexadecimal = "MALFORMED_HEXADECIMAL", n.CodePointLimit = "CODE_POINT_LIMIT", n.OctalDeprecation = "OCTAL_DEPRECATION", n.EndOfString = "END_OF_STRING";
  })(t = e.ErrorType || (e.ErrorType = {})), e.errorMessages = /* @__PURE__ */ new Map([
    [t.MalformedUnicode, "malformed Unicode character escape sequence"],
    [
      t.MalformedHexadecimal,
      "malformed hexadecimal character escape sequence"
    ],
    [
      t.CodePointLimit,
      "Unicode codepoint must not be greater than 0x10FFFF in escape sequence"
    ],
    [
      t.OctalDeprecation,
      '"0"-prefixed octal literals and octal escape sequences are deprecated; for octal literals use the "0o" prefix instead'
    ],
    [t.EndOfString, "malformed escape sequence at end of string"]
  ]);
})(Xt);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.unraw = e.errorMessages = e.ErrorType = void 0;
  const t = Xt;
  Object.defineProperty(e, "ErrorType", { enumerable: !0, get: function() {
    return t.ErrorType;
  } }), Object.defineProperty(e, "errorMessages", { enumerable: !0, get: function() {
    return t.errorMessages;
  } });
  function n(u) {
    return !u.match(/[^a-f0-9]/i) ? parseInt(u, 16) : NaN;
  }
  function r(u, v, N) {
    const A = n(u);
    if (Number.isNaN(A) || N !== void 0 && N !== u.length)
      throw new SyntaxError(t.errorMessages.get(v));
    return A;
  }
  function o(u) {
    const v = r(u, t.ErrorType.MalformedHexadecimal, 2);
    return String.fromCharCode(v);
  }
  function s(u, v) {
    const N = r(u, t.ErrorType.MalformedUnicode, 4);
    if (v !== void 0) {
      const A = r(v, t.ErrorType.MalformedUnicode, 4);
      return String.fromCharCode(N, A);
    }
    return String.fromCharCode(N);
  }
  function i(u) {
    return u.charAt(0) === "{" && u.charAt(u.length - 1) === "}";
  }
  function l(u) {
    if (!i(u))
      throw new SyntaxError(t.errorMessages.get(t.ErrorType.MalformedUnicode));
    const v = u.slice(1, -1), N = r(v, t.ErrorType.MalformedUnicode);
    try {
      return String.fromCodePoint(N);
    } catch (A) {
      throw A instanceof RangeError ? new SyntaxError(t.errorMessages.get(t.ErrorType.CodePointLimit)) : A;
    }
  }
  function d(u, v = !1) {
    if (v)
      throw new SyntaxError(t.errorMessages.get(t.ErrorType.OctalDeprecation));
    const N = parseInt(u, 8);
    return String.fromCharCode(N);
  }
  const m = /* @__PURE__ */ new Map([
    ["b", "\b"],
    ["f", "\f"],
    ["n", `
`],
    ["r", "\r"],
    ["t", "	"],
    ["v", "\v"],
    ["0", "\0"]
  ]);
  function g(u) {
    return m.get(u) || u;
  }
  const C = /\\(?:(\\)|x([\s\S]{0,2})|u(\{[^}]*\}?)|u([\s\S]{4})\\u([^{][\s\S]{0,3})|u([\s\S]{0,4})|([0-3]?[0-7]{1,2})|([\s\S])|$)/g;
  function S(u, v = !1) {
    return u.replace(C, function(N, A, k, P, w, E, p, _, U) {
      if (A !== void 0)
        return "\\";
      if (k !== void 0)
        return o(k);
      if (P !== void 0)
        return l(P);
      if (w !== void 0)
        return s(w, E);
      if (p !== void 0)
        return s(p);
      if (_ === "0")
        return "\0";
      if (_ !== void 0)
        return d(_, !v);
      if (U !== void 0)
        return g(U);
      throw new SyntaxError(t.errorMessages.get(t.ErrorType.EndOfString));
    });
  }
  e.unraw = S, e.default = S;
})(Zt);
var ke = {}, Jt = {}, Qt = { exports: {} };
(function(e) {
  (function(t, n) {
    e.exports ? e.exports = n() : t.moo = n();
  })(ft, function() {
    var t = Object.prototype.hasOwnProperty, n = Object.prototype.toString, r = typeof new RegExp().sticky == "boolean";
    function o(c) {
      return c && n.call(c) === "[object RegExp]";
    }
    function s(c) {
      return c && typeof c == "object" && !o(c) && !Array.isArray(c);
    }
    function i(c) {
      return c.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    function l(c) {
      var f = new RegExp("|" + c);
      return f.exec("").length - 1;
    }
    function d(c) {
      return "(" + c + ")";
    }
    function m(c) {
      if (!c.length) return "(?!)";
      var f = c.map(function(T) {
        return "(?:" + T + ")";
      }).join("|");
      return "(?:" + f + ")";
    }
    function g(c) {
      if (typeof c == "string")
        return "(?:" + i(c) + ")";
      if (o(c)) {
        if (c.ignoreCase) throw new Error("RegExp /i flag not allowed");
        if (c.global) throw new Error("RegExp /g flag is implied");
        if (c.sticky) throw new Error("RegExp /y flag is implied");
        if (c.multiline) throw new Error("RegExp /m flag is implied");
        return c.source;
      } else
        throw new Error("Not a pattern: " + c);
    }
    function C(c, f) {
      return c.length > f ? c : Array(f - c.length + 1).join(" ") + c;
    }
    function S(c, f) {
      for (var T = c.length, b = 0; ; ) {
        var G = c.lastIndexOf(`
`, T - 1);
        if (G === -1 || (b++, T = G, b === f) || T === 0)
          break;
      }
      var R = b < f ? 0 : T + 1;
      return c.substring(R).split(`
`);
    }
    function u(c) {
      for (var f = Object.getOwnPropertyNames(c), T = [], b = 0; b < f.length; b++) {
        var G = f[b], R = c[G], x = [].concat(R);
        if (G === "include") {
          for (var W = 0; W < x.length; W++)
            T.push({ include: x[W] });
          continue;
        }
        var H = [];
        x.forEach(function(L) {
          s(L) ? (H.length && T.push(N(G, H)), T.push(N(G, L)), H = []) : H.push(L);
        }), H.length && T.push(N(G, H));
      }
      return T;
    }
    function v(c) {
      for (var f = [], T = 0; T < c.length; T++) {
        var b = c[T];
        if (b.include) {
          for (var G = [].concat(b.include), R = 0; R < G.length; R++)
            f.push({ include: G[R] });
          continue;
        }
        if (!b.type)
          throw new Error("Rule has no type: " + JSON.stringify(b));
        f.push(N(b.type, b));
      }
      return f;
    }
    function N(c, f) {
      if (s(f) || (f = { match: f }), f.include)
        throw new Error("Matching rules cannot also include states");
      var T = {
        defaultType: c,
        lineBreaks: !!f.error || !!f.fallback,
        pop: !1,
        next: null,
        push: null,
        error: !1,
        fallback: !1,
        value: null,
        type: null,
        shouldThrow: !1
      };
      for (var b in f)
        t.call(f, b) && (T[b] = f[b]);
      if (typeof T.type == "string" && c !== T.type)
        throw new Error("Type transform cannot be a string (type '" + T.type + "' for token '" + c + "')");
      var G = T.match;
      return T.match = Array.isArray(G) ? G : G ? [G] : [], T.match.sort(function(R, x) {
        return o(R) && o(x) ? 0 : o(x) ? -1 : o(R) ? 1 : x.length - R.length;
      }), T;
    }
    function A(c) {
      return Array.isArray(c) ? v(c) : u(c);
    }
    var k = N("error", { lineBreaks: !0, shouldThrow: !0 });
    function P(c, f) {
      for (var T = null, b = /* @__PURE__ */ Object.create(null), G = !0, R = null, x = [], W = [], H = 0; H < c.length; H++)
        c[H].fallback && (G = !1);
      for (var H = 0; H < c.length; H++) {
        var L = c[H];
        if (L.include)
          throw new Error("Inheritance is not allowed in stateless lexers");
        if (L.error || L.fallback) {
          if (T)
            throw !L.fallback == !T.fallback ? new Error("Multiple " + (L.fallback ? "fallback" : "error") + " rules not allowed (for token '" + L.defaultType + "')") : new Error("fallback and error are mutually exclusive (for token '" + L.defaultType + "')");
          T = L;
        }
        var $ = L.match.slice();
        if (G)
          for (; $.length && typeof $[0] == "string" && $[0].length === 1; ) {
            var O = $.shift();
            b[O.charCodeAt(0)] = L;
          }
        if (L.pop || L.push || L.next) {
          if (!f)
            throw new Error("State-switching options are not allowed in stateless lexers (for token '" + L.defaultType + "')");
          if (L.fallback)
            throw new Error("State-switching options are not allowed on fallback tokens (for token '" + L.defaultType + "')");
        }
        if ($.length !== 0) {
          G = !1, x.push(L);
          for (var le = 0; le < $.length; le++) {
            var pe = $[le];
            if (o(pe)) {
              if (R === null)
                R = pe.unicode;
              else if (R !== pe.unicode && L.fallback === !1)
                throw new Error("If one rule is /u then all must be");
            }
          }
          var ue = m($.map(g)), te = new RegExp(ue);
          if (te.test(""))
            throw new Error("RegExp matches empty string: " + te);
          var Ae = l(ue);
          if (Ae > 0)
            throw new Error("RegExp has capture groups: " + te + `
Use (?: … ) instead`);
          if (!L.lineBreaks && te.test(`
`))
            throw new Error("Rule should declare lineBreaks: " + te);
          W.push(d(ue));
        }
      }
      var fe = T && T.fallback, he = r && !fe ? "ym" : "gm", Ie = r || fe ? "" : "|";
      R === !0 && (he += "u");
      var Me = new RegExp(m(W) + Ie, he);
      return { regexp: Me, groups: x, fast: b, error: T || k };
    }
    function w(c) {
      var f = P(A(c));
      return new U({ start: f }, "start");
    }
    function E(c, f, T) {
      var b = c && (c.push || c.next);
      if (b && !T[b])
        throw new Error("Missing state '" + b + "' (in token '" + c.defaultType + "' of state '" + f + "')");
      if (c && c.pop && +c.pop != 1)
        throw new Error("pop must be 1 (in token '" + c.defaultType + "' of state '" + f + "')");
    }
    function p(c, f) {
      var T = c.$all ? A(c.$all) : [];
      delete c.$all;
      var b = Object.getOwnPropertyNames(c);
      f || (f = b[0]);
      for (var G = /* @__PURE__ */ Object.create(null), R = 0; R < b.length; R++) {
        var x = b[R];
        G[x] = A(c[x]).concat(T);
      }
      for (var R = 0; R < b.length; R++)
        for (var x = b[R], W = G[x], H = /* @__PURE__ */ Object.create(null), L = 0; L < W.length; L++) {
          var $ = W[L];
          if ($.include) {
            var O = [L, 1];
            if ($.include !== x && !H[$.include]) {
              H[$.include] = !0;
              var le = G[$.include];
              if (!le)
                throw new Error("Cannot include nonexistent state '" + $.include + "' (in state '" + x + "')");
              for (var pe = 0; pe < le.length; pe++) {
                var ue = le[pe];
                W.indexOf(ue) === -1 && O.push(ue);
              }
            }
            W.splice.apply(W, O), L--;
          }
        }
      for (var te = /* @__PURE__ */ Object.create(null), R = 0; R < b.length; R++) {
        var x = b[R];
        te[x] = P(G[x], !0);
      }
      for (var R = 0; R < b.length; R++) {
        for (var Ae = b[R], fe = te[Ae], he = fe.groups, L = 0; L < he.length; L++)
          E(he[L], Ae, te);
        for (var Ie = Object.getOwnPropertyNames(fe.fast), L = 0; L < Ie.length; L++)
          E(fe.fast[Ie[L]], Ae, te);
      }
      return new U(te, f);
    }
    function _(c) {
      for (var f = typeof Map < "u", T = f ? /* @__PURE__ */ new Map() : /* @__PURE__ */ Object.create(null), b = Object.getOwnPropertyNames(c), G = 0; G < b.length; G++) {
        var R = b[G], x = c[R], W = Array.isArray(x) ? x : [x];
        W.forEach(function(H) {
          if (typeof H != "string")
            throw new Error("keyword must be string (in keyword '" + R + "')");
          f ? T.set(H, R) : T[H] = R;
        });
      }
      return function(H) {
        return f ? T.get(H) : T[H];
      };
    }
    var U = function(c, f) {
      this.startState = f, this.states = c, this.buffer = "", this.stack = [], this.reset();
    };
    U.prototype.reset = function(c, f) {
      return this.buffer = c || "", this.index = 0, this.line = f ? f.line : 1, this.col = f ? f.col : 1, this.queuedToken = f ? f.queuedToken : null, this.queuedText = f ? f.queuedText : "", this.queuedThrow = f ? f.queuedThrow : null, this.setState(f ? f.state : this.startState), this.stack = f && f.stack ? f.stack.slice() : [], this;
    }, U.prototype.save = function() {
      return {
        line: this.line,
        col: this.col,
        state: this.state,
        stack: this.stack.slice(),
        queuedToken: this.queuedToken,
        queuedText: this.queuedText,
        queuedThrow: this.queuedThrow
      };
    }, U.prototype.setState = function(c) {
      if (!(!c || this.state === c)) {
        this.state = c;
        var f = this.states[c];
        this.groups = f.groups, this.error = f.error, this.re = f.regexp, this.fast = f.fast;
      }
    }, U.prototype.popState = function() {
      this.setState(this.stack.pop());
    }, U.prototype.pushState = function(c) {
      this.stack.push(this.state), this.setState(c);
    };
    var B = r ? function(c, f) {
      return c.exec(f);
    } : function(c, f) {
      var T = c.exec(f);
      return T[0].length === 0 ? null : T;
    };
    U.prototype._getGroup = function(c) {
      for (var f = this.groups.length, T = 0; T < f; T++)
        if (c[T + 1] !== void 0)
          return this.groups[T];
      throw new Error("Cannot find token type for matched text");
    };
    function ce() {
      return this.value;
    }
    if (U.prototype.next = function() {
      var c = this.index;
      if (this.queuedGroup) {
        var f = this._token(this.queuedGroup, this.queuedText, c);
        return this.queuedGroup = null, this.queuedText = "", f;
      }
      var T = this.buffer;
      if (c !== T.length) {
        var x = this.fast[T.charCodeAt(c)];
        if (x)
          return this._token(x, T.charAt(c), c);
        var b = this.re;
        b.lastIndex = c;
        var G = B(b, T), R = this.error;
        if (G == null)
          return this._token(R, T.slice(c, T.length), c);
        var x = this._getGroup(G), W = G[0];
        return R.fallback && G.index !== c ? (this.queuedGroup = x, this.queuedText = W, this._token(R, T.slice(c, G.index), c)) : this._token(x, W, c);
      }
    }, U.prototype._token = function(c, f, T) {
      var b = 0;
      if (c.lineBreaks) {
        var G = /\n/g, R = 1;
        if (f === `
`)
          b = 1;
        else
          for (; G.exec(f); )
            b++, R = G.lastIndex;
      }
      var x = {
        type: typeof c.type == "function" && c.type(f) || c.defaultType,
        value: typeof c.value == "function" ? c.value(f) : f,
        text: f,
        toString: ce,
        offset: T,
        lineBreaks: b,
        line: this.line,
        col: this.col
      }, W = f.length;
      if (this.index += W, this.line += b, b !== 0 ? this.col = W - R + 1 : this.col += W, c.shouldThrow) {
        var H = new Error(this.formatError(x, "invalid syntax"));
        throw H;
      }
      return c.pop ? this.popState() : c.push ? this.pushState(c.push) : c.next && this.setState(c.next), x;
    }, typeof Symbol < "u" && Symbol.iterator) {
      var F = function(c) {
        this.lexer = c;
      };
      F.prototype.next = function() {
        var c = this.lexer.next();
        return { value: c, done: !c };
      }, F.prototype[Symbol.iterator] = function() {
        return this;
      }, U.prototype[Symbol.iterator] = function() {
        return new F(this);
      };
    }
    return U.prototype.formatError = function(c, f) {
      if (c == null)
        var T = this.buffer.slice(this.index), c = {
          text: T,
          offset: this.index,
          lineBreaks: T.indexOf(`
`) === -1 ? 0 : 1,
          line: this.line,
          col: this.col
        };
      var b = 2, G = Math.max(c.line - b, 1), R = c.line + b, x = String(R).length, W = S(
        this.buffer,
        this.line - c.line + b + 1
      ).slice(0, 5), H = [];
      H.push(f + " at line " + c.line + " col " + c.col + ":"), H.push("");
      for (var L = 0; L < W.length; L++) {
        var $ = W[L], O = G + L;
        H.push(C(String(O), x) + "  " + $), O === c.line && H.push(C("", x + c.col + 1) + "^");
      }
      return H.join(`
`);
    }, U.prototype.clone = function() {
      return new U(this.states, this.state);
    }, U.prototype.has = function(c) {
      return !0;
    }, {
      compile: w,
      states: p,
      error: Object.freeze({ error: !0 }),
      fallback: Object.freeze({ fallback: !0 }),
      keywords: _
    };
  });
})(Qt);
var zr = Qt.exports;
(function(e) {
  var t = ft && ft.__importDefault || function(r) {
    return r && r.__esModule ? r : { default: r };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.lexer = e.states = void 0;
  const n = t(zr);
  e.states = {
    body: {
      doubleapos: { match: "''", value: () => "'" },
      quoted: {
        lineBreaks: !0,
        match: /'[{}#](?:[^]*?[^'])?'(?!')/u,
        value: (r) => r.slice(1, -1).replace(/''/g, "'")
      },
      argument: {
        lineBreaks: !0,
        match: /\{\s*[^\p{Pat_Syn}\p{Pat_WS}]+\s*/u,
        push: "arg",
        value: (r) => r.substring(1).trim()
      },
      octothorpe: "#",
      end: { match: "}", pop: 1 },
      content: { lineBreaks: !0, match: /[^][^{}#']*/u }
    },
    arg: {
      select: {
        lineBreaks: !0,
        match: /,\s*(?:plural|select|selectordinal)\s*,\s*/u,
        next: "select",
        value: (r) => r.split(",")[1].trim()
      },
      "func-args": {
        lineBreaks: !0,
        match: /,\s*[^\p{Pat_Syn}\p{Pat_WS}]+\s*,/u,
        next: "body",
        value: (r) => r.split(",")[1].trim()
      },
      "func-simple": {
        lineBreaks: !0,
        match: /,\s*[^\p{Pat_Syn}\p{Pat_WS}]+\s*/u,
        value: (r) => r.substring(1).trim()
      },
      end: { match: "}", pop: 1 }
    },
    select: {
      offset: {
        lineBreaks: !0,
        match: /\s*offset\s*:\s*\d+\s*/u,
        value: (r) => r.split(":")[1].trim()
      },
      case: {
        lineBreaks: !0,
        match: /\s*(?:=\d+|[^\p{Pat_Syn}\p{Pat_WS}]+)\s*\{/u,
        push: "body",
        value: (r) => r.substring(0, r.indexOf("{")).trim()
      },
      end: { match: /\s*\}/u, pop: 1 }
    }
  }, e.lexer = n.default.states(e.states);
})(Jt);
Object.defineProperty(ke, "__esModule", { value: !0 });
var er = ke.parse = ke.ParseError = void 0;
const tr = Jt, Fe = (e) => ({
  offset: e.offset,
  line: e.line,
  col: e.col,
  text: e.text,
  lineBreaks: e.lineBreaks
}), dt = (e) => e === "plural" || e === "select" || e === "selectordinal";
function qr(e, t) {
  let n = "", r = "";
  for (const s of t) {
    const i = s.ctx.text;
    switch (r += i, s.type) {
      case "content":
        n += s.value;
        break;
      case "argument":
      case "function":
      case "octothorpe":
        n += i;
        break;
      default:
        throw new Y(e, `Unsupported part in strict mode function arg style: ${i}`);
    }
  }
  return [{
    type: "content",
    value: n.trim(),
    ctx: Object.assign({}, t[0].ctx, { text: r })
  }];
}
const Yr = [
  "number",
  "date",
  "time",
  "spellout",
  "ordinal",
  "duration"
], Ht = ["zero", "one", "two", "few", "many", "other"];
class Y extends Error {
  /** @internal */
  constructor(t, n) {
    super(tr.lexer.formatError(t, n));
  }
}
ke.ParseError = Y;
class Kr {
  constructor(t, n) {
    var r, o, s, i;
    this.lexer = tr.lexer.reset(t), this.cardinalKeys = (r = n == null ? void 0 : n.cardinal) !== null && r !== void 0 ? r : Ht, this.ordinalKeys = (o = n == null ? void 0 : n.ordinal) !== null && o !== void 0 ? o : Ht, this.strict = (s = n == null ? void 0 : n.strict) !== null && s !== void 0 ? s : !1, this.strictPluralKeys = (i = n == null ? void 0 : n.strictPluralKeys) !== null && i !== void 0 ? i : !0;
  }
  parse() {
    return this.parseBody(!1, !0);
  }
  checkSelectKey(t, n, r) {
    if (r[0] === "=") {
      if (n === "select")
        throw new Y(t, `The case ${r} is not valid with select`);
    } else if (n !== "select") {
      const o = n === "plural" ? this.cardinalKeys : this.ordinalKeys;
      if (this.strictPluralKeys && o.length > 0 && !o.includes(r)) {
        const s = `The ${n} case ${r} is not valid in this locale`;
        throw new Y(t, s);
      }
    }
  }
  parseSelect({ value: t }, n, r, o) {
    const s = { type: o, arg: t, cases: [], ctx: r };
    o === "plural" || o === "selectordinal" ? n = !0 : this.strict && (n = !1);
    for (const i of this.lexer)
      switch (i.type) {
        case "offset":
          if (o === "select")
            throw new Y(i, "Unexpected plural offset for select");
          if (s.cases.length > 0)
            throw new Y(i, "Plural offset must be set before cases");
          s.pluralOffset = Number(i.value), r.text += i.text, r.lineBreaks += i.lineBreaks;
          break;
        case "case": {
          this.checkSelectKey(i, o, i.value), s.cases.push({
            key: i.value,
            tokens: this.parseBody(n),
            ctx: Fe(i)
          });
          break;
        }
        case "end":
          return s;
        default:
          throw new Y(i, `Unexpected lexer token: ${i.type}`);
      }
    throw new Y(null, "Unexpected message end");
  }
  parseArgToken(t, n) {
    const r = Fe(t), o = this.lexer.next();
    if (!o)
      throw new Y(null, "Unexpected message end");
    if (r.text += o.text, r.lineBreaks += o.lineBreaks, this.strict && (o.type === "func-simple" || o.type === "func-args") && !Yr.includes(o.value)) {
      const s = `Invalid strict mode function arg type: ${o.value}`;
      throw new Y(t, s);
    }
    switch (o.type) {
      case "end":
        return { type: "argument", arg: t.value, ctx: r };
      case "func-simple": {
        const s = this.lexer.next();
        if (!s)
          throw new Y(null, "Unexpected message end");
        if (s.type !== "end")
          throw new Y(s, `Unexpected lexer token: ${s.type}`);
        if (r.text += s.text, dt(o.value.toLowerCase()))
          throw new Y(o, `Invalid type identifier: ${o.value}`);
        return {
          type: "function",
          arg: t.value,
          key: o.value,
          ctx: r
        };
      }
      case "func-args": {
        if (dt(o.value.toLowerCase())) {
          const i = `Invalid type identifier: ${o.value}`;
          throw new Y(o, i);
        }
        let s = this.parseBody(this.strict ? !1 : n);
        return this.strict && s.length > 0 && (s = qr(t, s)), {
          type: "function",
          arg: t.value,
          key: o.value,
          param: s,
          ctx: r
        };
      }
      case "select":
        if (dt(o.value))
          return this.parseSelect(t, n, r, o.value);
        throw new Y(o, `Unexpected select type ${o.value}`);
      default:
        throw new Y(o, `Unexpected lexer token: ${o.type}`);
    }
  }
  parseBody(t, n) {
    const r = [];
    let o = null;
    for (const s of this.lexer)
      if (s.type === "argument")
        o && (o = null), r.push(this.parseArgToken(s, t));
      else if (s.type === "octothorpe" && t)
        o && (o = null), r.push({ type: "octothorpe", ctx: Fe(s) });
      else {
        if (s.type === "end" && !n)
          return r;
        {
          let i = s.value;
          if (!t && s.type === "quoted" && i[0] === "#") {
            if (i.includes("{")) {
              const l = `Unsupported escape pattern: ${i}`;
              throw new Y(s, l);
            }
            i = s.text;
          }
          o ? (o.value += i, o.ctx.text += s.text, o.ctx.lineBreaks += s.lineBreaks) : (o = { type: "content", value: i, ctx: Fe(s) }, r.push(o));
        }
      }
    if (n)
      return r;
    throw new Y(null, "Unexpected message end");
  }
}
function Zr(e, t = {}) {
  return new Kr(e, t).parse();
}
er = ke.parse = Zr;
function rr(e, t) {
  return e.filter((n) => n.type !== "content").length ? e.map((n) => {
    var s;
    if (n.type === "content")
      return t(n.value);
    if (n.type === "octothorpe")
      return "#";
    if (n.type === "argument")
      return [n.arg];
    if (n.type === "function") {
      const i = (s = n == null ? void 0 : n.param) == null ? void 0 : s[0];
      return i ? [n.arg, n.key, i.value.trim()] : [n.arg, n.key];
    }
    const r = n.pluralOffset, o = {};
    return n.cases.forEach(({ key: i, tokens: l }) => {
      const d = i[0] === "=" ? i.slice(1) : i;
      o[d] = rr(l, t);
    }), [
      n.arg,
      n.type,
      {
        offset: r,
        ...o
      }
    ];
  }) : e.map((n) => t(n.value)).join("");
}
function Xr(e, t = (n) => n) {
  try {
    return rr(er(e), t);
  } catch (n) {
    return console.error(`${n.message} 

Message: ${e}`), e;
  }
}
const Te = (e) => typeof e == "string", Jr = (e) => typeof e == "function", Bt = /* @__PURE__ */ new Map(), nr = "en";
function bt(e) {
  return [...Array.isArray(e) ? e : [e], nr];
}
function or(e, t, n) {
  const r = bt(e);
  return je(
    () => ze("date", r, n),
    () => new Intl.DateTimeFormat(r, n)
  ).format(Te(t) ? new Date(t) : t);
}
function vt(e, t, n) {
  const r = bt(e);
  return je(
    () => ze("number", r, n),
    () => new Intl.NumberFormat(r, n)
  ).format(t);
}
function Ft(e, t, n, { offset: r = 0, ...o }) {
  const s = bt(e), i = t ? je(
    () => ze("plural-ordinal", s),
    () => new Intl.PluralRules(s, { type: "ordinal" })
  ) : je(
    () => ze("plural-cardinal", s),
    () => new Intl.PluralRules(s, { type: "cardinal" })
  );
  return o[n] ?? o[i.select(n - r)] ?? o.other;
}
function je(e, t) {
  const n = e();
  let r = Bt.get(n);
  return r || (r = t(), Bt.set(n, r)), r;
}
function ze(e, t, n) {
  const r = t.join("-");
  return `${e}-${r}-${JSON.stringify(n)}`;
}
const sr = /\\u[a-fA-F0-9]{4}|\\x[a-fA-F0-9]{2}/, ar = "%__lingui_octothorpe__%", Qr = (e, t, n = {}) => {
  const r = t || e, o = (i) => typeof i == "object" ? i : n[i] || { style: i }, s = (i, l) => {
    const d = Object.keys(n).length ? o("number") : void 0, m = vt(r, i, d);
    return l.replace(new RegExp(ar, "g"), m);
  };
  return {
    plural: (i, l) => {
      const { offset: d = 0 } = l, m = Ft(r, !1, i, l);
      return s(i - d, m);
    },
    selectordinal: (i, l) => {
      const { offset: d = 0 } = l, m = Ft(r, !0, i, l);
      return s(i - d, m);
    },
    select: en,
    number: (i, l) => vt(r, i, o(l)),
    date: (i, l) => or(r, i, o(l))
  };
}, en = (e, t) => t[e] ?? t.other;
function tn(e, t, n) {
  return (r = {}, o) => {
    const s = Qr(t, n, o), i = (d, m = !1) => Array.isArray(d) ? d.reduce((g, C) => {
      if (C === "#" && m)
        return g + ar;
      if (Te(C))
        return g + C;
      const [S, u, v] = C;
      let N = {};
      u === "plural" || u === "selectordinal" || u === "select" ? Object.entries(v).forEach(
        ([k, P]) => {
          N[k] = i(
            P,
            u === "plural" || u === "selectordinal"
          );
        }
      ) : N = v;
      let A;
      if (u) {
        const k = s[u];
        A = k(r[S], N);
      } else
        A = r[S];
      return A == null ? g : g + A;
    }, "") : d, l = i(e);
    return Te(l) && sr.test(l) ? Zt.unraw(l.trim()) : Te(l) ? l.trim() : l ? String(l) : "";
  };
}
var rn = Object.defineProperty, nn = (e, t, n) => t in e ? rn(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, on = (e, t, n) => (nn(e, t + "", n), n);
class sn {
  constructor() {
    on(this, "_events", {});
  }
  on(t, n) {
    var r;
    return (r = this._events)[t] ?? (r[t] = []), this._events[t].push(n), () => this.removeListener(t, n);
  }
  removeListener(t, n) {
    const r = this._getListeners(t);
    if (!r)
      return;
    const o = r.indexOf(n);
    ~o && r.splice(o, 1);
  }
  emit(t, ...n) {
    const r = this._getListeners(t);
    r && r.map((o) => o.apply(this, n));
  }
  _getListeners(t) {
    const n = this._events[t];
    return Array.isArray(n) ? n : !1;
  }
}
var an = Object.defineProperty, ln = (e, t, n) => t in e ? an(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Pe = (e, t, n) => (ln(e, typeof t != "symbol" ? t + "" : t, n), n);
class cn extends sn {
  constructor(t) {
    super(), Pe(this, "_locale", ""), Pe(this, "_locales"), Pe(this, "_localeData", {}), Pe(this, "_messages", {}), Pe(this, "_missing"), Pe(this, "t", this._.bind(this)), t.missing != null && (this._missing = t.missing), t.messages != null && this.load(t.messages), t.localeData != null && this.loadLocaleData(t.localeData), (typeof t.locale == "string" || t.locales) && this.activate(t.locale ?? nr, t.locales);
  }
  get locale() {
    return this._locale;
  }
  get locales() {
    return this._locales;
  }
  get messages() {
    return this._messages[this._locale] ?? {};
  }
  /**
   * @deprecated this has no effect. Please remove this from the code. Deprecated in v4
   */
  get localeData() {
    return this._localeData[this._locale] ?? {};
  }
  _loadLocaleData(t, n) {
    const r = this._localeData[t];
    r ? Object.assign(r, n) : this._localeData[t] = n;
  }
  /**
   * @deprecated Plurals automatically used from Intl.PluralRules you can safely remove this call. Deprecated in v4
   */
  // @ts-ignore deprecated, so ignore the reported error
  loadLocaleData(t, n) {
    n != null ? this._loadLocaleData(t, n) : Object.keys(t).forEach(
      (r) => this._loadLocaleData(r, t[r])
    ), this.emit("change");
  }
  _load(t, n) {
    const r = this._messages[t];
    r ? Object.assign(r, n) : this._messages[t] = n;
  }
  load(t, n) {
    typeof t == "string" && typeof n == "object" ? this._load(t, n) : Object.entries(t).forEach(
      ([r, o]) => this._load(r, o)
    ), this.emit("change");
  }
  /**
   * @param options {@link LoadAndActivateOptions}
   */
  loadAndActivate({ locale: t, locales: n, messages: r }) {
    this._locale = t, this._locales = n || void 0, this._messages[this._locale] = r, this.emit("change");
  }
  activate(t, n) {
    process.env.NODE_ENV !== "production" && (this._messages[t] || console.warn(`Messages for locale "${t}" not loaded.`)), this._locale = t, this._locales = n, this.emit("change");
  }
  _(t, n, r) {
    let o = r == null ? void 0 : r.message;
    t || (t = ""), Te(t) || (n = t.values || n, o = t.message, t = t.id);
    const s = this.messages[t], i = s === void 0, l = this._missing;
    if (l && i)
      return Jr(l) ? l(this._locale, t) : l;
    i && this.emit("missing", { id: t, locale: this._locale });
    let d = s || o || t;
    return process.env.NODE_ENV !== "production" && (d = Te(d) ? Xr(d) : d), Te(d) && sr.test(d) ? JSON.parse(`"${d}"`) : Te(d) ? d : tn(
      d,
      this._locale,
      this._locales
    )(n, r == null ? void 0 : r.formats);
  }
  date(t, n) {
    return or(this._locales || this._locale, t, n);
  }
  number(t, n) {
    return vt(this._locales || this._locale, t, n);
  }
}
function un(e = {}) {
  return new cn(e);
}
const Ce = un(), dn = JSON.parse('{"DR9T8G":"Acting on behalf of ","8ubKza":"DataVentures Menu","i0qMbr":"Home","z0t9bb":"Login","PYeR3u":"LumianteMenu","SVTHNu":"Return to Company List","5WSbeX":"Scintilla","3PpUfG":"Supplier View","bTdmV9":"View Apps","RVWz5F":"Viewing","wOSCp2":"Walmart Merchant View"}'), pn = JSON.parse('{"DR9T8G":"Actuando en nombre de ","8ubKza":"Menú de Data Ventures","i0qMbr":"Inicio","z0t9bb":"Inicio de sesión","PYeR3u":"LumianteMenu","SVTHNu":"Regresar a la lista de compañías","5WSbeX":"Scintilla","3PpUfG":"Vista del proveedor","bTdmV9":"Ver aplicaciones","RVWz5F":"Visualización","wOSCp2":"Vista del comprador de Walmart"}'), hn = JSON.parse('{"DR9T8G":"Agissant au nom de","8ubKza":"Menu DataVentures","i0qMbr":"Articles pour la maison","z0t9bb":"Ouvrir une session","PYeR3u":"LumianteMenu","SVTHNu":"Retour à la liste des entreprises","5WSbeX":"Scintilla","3PpUfG":"Vue du fournisseur","bTdmV9":"Afficher les applications","RVWz5F":"Afficher","wOSCp2":"Vue du marchand Walmart"}');
Ce.load({
  "en-US": dn,
  "es-MX": pn,
  "fr-CA": hn
});
const gn = {
  SUCCESS: "success",
  HTTP_METHODS: {
    POST: "POST",
    GET: "GET",
    DELETE: "DELETE",
    PATCH: "PATCH",
    PUT: "PUT"
  },
  HTTP_REQ_ERROR_MAP: {
    401: {
      statusCode: 401,
      errorMessage: z.NOT_AUTHORIZED
    },
    403: {
      statusCode: 403,
      errorMessage: z.ACCESS_DENIED
    },
    404: {
      statusCode: 404,
      errorMessage: z.NO_DATA_AVAILABLE
    },
    405: {
      statusCode: 405,
      errorMessage: z.METHOD_NOT_ALLOWED
    }
  },
  HTTP_REQ_DEFAULT_HEADERS: {
    crossDomain: !0,
    "Content-Type": "text/plain;charset=utf-8",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Credentials": !0,
    "Access-Control-Allow-Methods": "GET, POST, OPTIONS",
    "Access-Control-Allow-Headers": "Origin, Content-Type, Accept",
    "Cache-Control": "no-cache, no-store, must-revalidate"
  },
  CONTENT_TYPE: {
    appJson: "application/json",
    multiPartFromData: "multipart/formdata",
    octetStream: "application/octet-stream"
  }
}, q = {
  VALIDATE_UPC_GROUPS: "VALIDATE_UPC_GROUPS",
  VALIDATE_UPC_ITEMS: "VALIDATE_UPC_ITEMS",
  CREATE_CUSTOM_GROUPS: "CREATE_CUSTOM_GROUPS",
  CREATE_CUSTOM_GROUPS_FROM_FILE: "CREATE_CUSTOM_GROUPS_FROM_FILE",
  GET_CUSTOM_GROUPS: "GET_CUSTOM_GROUPS",
  GET_CUSTOM_GROUP_BY_TEXT: "GET_CUSTOM_GROUPS_BY_TEXT",
  GET_GROUP_DETAILS_BY_ID: "GET_GROUP_DETAILS_BY_ID",
  UPLOAD_FILE: "UPLOAD_FILE",
  DOWNLOAD_FILE: "DOWNLOAD_FILE",
  USER_INFO: "USER_INFO",
  PRODUCTS: "PRODUCTS",
  FAVOURITE_UPC: "FAVOURITE_UPC",
  PENDING_ANNOUNCEMENTS: "PENDING_ANNOUNCEMENTS",
  ANNOUNCEMENT_DETAILS: "ANNOUNCEMENT_DETAILS",
  ACKNOWLEDGE_ANNOUNCEMENTS: "ACKNOWLEDGE_ANNOUNCEMENTS",
  SWITCH_CONTEXT: "SWITCH_CONTEXT",
  IDENTITY_SITE: "IDENTITY_SITE",
  PRODUCT_HIERARCHIES_SUB_GRAPH: "PRODUCT_HIERARCHIES_SUB_GRAPH"
}, mn = {
  [q.VALIDATE_UPC_ITEMS]: "/appAsset/custom-group/validate/items",
  [q.VALIDATE_UPC_GROUPS]: "/appAsset/custom-group/validate/groups",
  [q.CREATE_CUSTOM_GROUPS]: "/asset/app/v1/asset/custom-group",
  [q.CREATE_CUSTOM_GROUPS_FROM_FILE]: "/asset/app/v1/asset/custom-group/file",
  [q.GET_CUSTOM_GROUPS]: "/asset/app/v1/asset/custom-group",
  [q.GET_CUSTOM_GROUP_BY_TEXT]: "/asset/app/v1/asset/custom-group/search-result",
  [q.GET_GROUP_DETAILS_BY_ID]: "/asset/app/v1/asset/custom-group",
  [q.UPLOAD_FILE]: "/appAsset/custom-group-file",
  [q.DOWNLOAD_FILE]: "/asset/app/v1/asset/custom-group/file-template",
  [q.USER_INFO]: "/v1/identity/user-context",
  [q.PRODUCTS]: "/v1/products",
  [q.IDENTITY_SITE]: "/v1/identity/sites",
  // TODO: Update this with the actual API
  [q.FAVOURITE_UPC]: "/core-app-api/user-info",
  [q.PENDING_ANNOUNCEMENTS]: "/core-app-api/user/pendingAnnouncements",
  [q.ANNOUNCEMENT_DETAILS]: "/core-app-api/announcements",
  [q.ACKNOWLEDGE_ANNOUNCEMENTS]: "/core-app-api/user/acknowledgedAnnouncements",
  [q.SWITCH_CONTEXT]: "/core-app-api/users/switch-context",
  [q.PRODUCT_HIERARCHIES_SUB_GRAPH]: "/coregraphql"
}, fn = Object.freeze({
  searchBrands: "searchBrands",
  searchCategories: "searchCategories",
  getProductGroupUpcList: "getProductGroupUpcList",
  getProductGroup: "getProductGroup"
}), vn = {
  appName: "Application Assets-Custom Groups",
  groupName: "Group Name",
  path: "Path",
  lastEdit: "Last Edit",
  newGroup: "New group",
  clearAll: "Clear all",
  apply: "Apply",
  select: "Select",
  create: "Create",
  optional: "Optional",
  groupDetails: "Group details",
  groupInfo: "Group Information",
  groupValues: "Group Values",
  name: "Name",
  description: "Description",
  creator: "Creator",
  application: "Application",
  selectProductGroup: "Select Product Group",
  createGroup: "Create Group",
  fileUpload: "File Upload",
  textInput: "Text Input",
  createGroupHint: "All group will be shared across your orgnization",
  chooseFile: "Choose file",
  deleteFile: "Delete File",
  size: "Size",
  downloadTemplate: "Download template",
  downlodTemplateSuffix: "to see an example for format required",
  continue: "Continue",
  searchByText: "Search by text",
  source: "Source",
  view: "View"
}, _n = {
  header: "HEADER",
  menu: "MENU",
  footer: "FOOTER"
}, we = {
  us: "scintilla.com",
  mexico: "scintilla.mx",
  canada: "scintillacanada.com",
  usWL: "walmartluminate.com",
  mexicoWL: "walmartdataventures.mx",
  canadaWL: "walmartdataventures.ca"
}, Cn = {
  [we.us]: "WMT-US",
  [we.mexico]: "WMT-MX",
  [we.canada]: "WMT-CA",
  [we.usWL]: "WMT-US",
  [we.mexicoWL]: "WMT-MX",
  [we.canadaWL]: "WMT-CA"
}, yn = {
  en: "EN"
}, Sn = {
  us: "US"
}, En = [
  "SHOPPER_BEHAVIOR"
], Tn = {
  bannerID: "super-admin-return-back-banner",
  group: "Super Admin",
  validBannerMessage: {
    id: "DR9T8G"
  },
  invalidBannerMessage: "Select company to represent for "
}, bn = {
  bannerID: "super-admin-spectator-return-back-banner",
  group: "Super Admin Spectator",
  validBannerMessage: {
    id: "RVWz5F"
  },
  invalidBannerMessage: "Select company to view for "
}, An = {
  bannerID: "3p-sponsored-supplier-return-back-banner",
  group: "Regular User",
  validBannerMessage: {
    id: "RVWz5F"
  },
  invalidBannerMessage: "Select company to view for "
}, In = {
  action: "SWITCH",
  resourceName: "COMPANY"
}, Nn = {
  action: "SWITCH",
  resourceName: "PERSONA"
}, wn = {
  id: "SVTHNu"
}, On = "Scintilla", Ln = "CUSTOMER_PERCEPTION", Mn = "balance", Pn = "merchantViewPage", Rn = "supplierViewPage", Un = {
  id: "3PpUfG"
}, Gn = {
  id: "wOSCp2"
}, Dn = "globalAdmin", xn = "admin", kn = {
  id: "z0t9bb"
}, Hn = {
  id: "bTdmV9"
}, Bn = "selectedSubMenuKey", Fn = "BASIC_VENDOR", Vn = {
  id: "i0qMbr"
}, Wn = {
  COMPANY_LIST: "/companyList",
  APPS: "/apps",
  BASIC_USER_KB: "/knowledgeBase/basic"
}, $n = {
  MARKETING: "/",
  DSS_LANDING: "/product/plans/details",
  DSS_MARKETING: "/plans",
  DSS_SIGN_UP: "/product/plans/sign_up"
}, jn = {
  landing: "/",
  globalUserManagement: "/globalUserManagement",
  companyList: "/companyList"
}, zn = {
  id: "8ubKza"
}, qn = "en-US", Yn = [
  "en-US",
  "es-MX",
  "fr-CA"
], Kn = "UNKNOWN", h = {
  httpMethods: gn,
  URL_KEY: q,
  URLS: mn,
  labels: vn,
  CUSTOMER_PERCEPTION_RESOURCE: Ln,
  SCINTILLA: On,
  BALANCE: Mn,
  hosts: we,
  domains: Cn,
  LOGO_LABEL: zn,
  languageCodes: yn,
  countryCodes: Sn,
  externalAccessProducts: En,
  SUPER_ADMIN: Tn,
  SUPER_ADMIN_SPECTATOR: bn,
  THIRD_PARTY_SPONSORED_SUPPLIER: An,
  MERCHANT_VIEW_PAGE: Pn,
  SUPPLIER_VIEW_PAGE: Rn,
  ROUTES: Wn,
  SUPPLIER_VIEW: Un,
  MERCHANT_VIEW: Gn,
  GLOBAL_ADMIN: Dn,
  ADMIN: xn,
  DEFAULT_LOCALE: qn,
  ALLOWED_LOCALE_VALUES: Yn,
  LOGIN_LABEL: kn,
  VIEW_APPS: Hn,
  HOME: Vn,
  locations: _n,
  switchCompanyPermission: In,
  switchPersonaPermission: Nn,
  RETURN_TO_COMPANY_LIST: wn,
  SELECTED_SUB_MENU: Bn,
  UNKNOWN_COMPANY_VALUES: Kn,
  allAccessRoutes: jn,
  BASIC_VENDOR: Fn,
  ROUTES_WITH_MARKETING_HEADER: $n,
  QUERY_KEYS: fn
}, Zn = ({ type: e, actionOn: t, location: n, ...r }) => {
  var o, s;
  window.__DATAVENTURES_PORTAL__ && (window.__DATAVENTURES_PORTAL__.dataLayer = {
    ...(o = window == null ? void 0 : window.__DATAVENTURES_PORTAL__) == null ? void 0 : o.dataLayer,
    [e]: t,
    location: n,
    appName: h.labels.appName,
    pageURL: (s = window == null ? void 0 : window.location) == null ? void 0 : s.href,
    ...r || {}
  }, Xn(`${e}Event`));
}, Xn = (e) => {
  var t, n, r;
  (r = (n = (t = window.__DATAVENTURES_PORTAL__) == null ? void 0 : t.dataLayer) == null ? void 0 : n.analyticsEvent) == null || r.push({ type: e });
}, Ue = {
  trackEventInfo: Zn
};
function Jn(e, t) {
  const { type: n, payload: r, location: o } = t;
  switch (n) {
    case _e.NewGroupButtonClicked:
    case _e.NewGroupCreationSubmitted: {
      Ue.trackEventInfo({
        type: "click",
        actionOn: n,
        location: o
      });
      break;
    }
    case _e.GroupsSelectionApplied: {
      Ue.trackEventInfo({
        type: "click",
        actionOn: n,
        location: o,
        customGroupsAppliedCount: r
      });
      break;
    }
  }
  return e;
}
function Qn(e, t) {
  const { type: n, payload: { groups: r, filters: o, selectedGroups: s, favouriteGroups: i, selectedGroup: l, currentPage: d, currentGroup: m, createGroupInput: g, createdGroup: C } = {} } = t;
  switch (n) {
    case D.GetGroups:
      return Object.assign(Object.assign({}, e), {
        groups: Object.assign(Object.assign({}, e.groups), {
          isLoading: !0
        })
      });
    case D.GetGroupsError:
      return Object.assign(Object.assign({}, e), {
        groups: {
          isLoading: !1,
          isError: !0,
          data: []
        }
      });
    case D.SetGroups:
      return Object.assign(Object.assign({}, e), {
        groups: {
          isError: !1,
          isLoading: !1,
          data: r ?? []
        }
      });
    case D.SetFilters:
      return Object.assign(Object.assign({}, e), {
        filters: o
      });
    case D.SetSelectedGroups:
      return Object.assign(Object.assign({}, e), {
        selectedGroups: s ?? []
      });
    case D.ClearSelectedGroups:
      return Object.assign(Object.assign({}, e), {
        defaultSelectedGroups: [],
        selectedGroups: [],
        filters: Object.assign(Object.assign({}, e.filters), {
          viewType: "All"
        })
      });
    case D.SetFavouriteGroups:
      return Object.assign(Object.assign({}, e), {
        favouriteGroups: i ?? []
      });
    case D.SetCurrentPage:
      return Object.assign(Object.assign(Object.assign(Object.assign({}, e), {
        currentPage: d ?? J.ListGroups
      }), l ? {
        selectedGroup: l
      } : {}), s ? {
        selectedGroups: s
      } : {});
    case D.SetSelectedGroup:
      return Object.assign(Object.assign({}, e), {
        selectedGroup: l ?? null
      });
    case D.GetGroup:
      return Object.assign(Object.assign({}, e), {
        currentGroup: Object.assign(Object.assign({}, e.currentGroup), {
          isLoading: !0
        })
      });
    case D.GetGroupError:
      return Object.assign(Object.assign({}, e), {
        currentGroup: Object.assign(Object.assign({}, e.currentGroup), {
          isLoading: !1,
          isError: !0
        })
      });
    case D.SetGroup:
      return Object.assign(Object.assign({}, e), {
        currentGroup: {
          isError: !1,
          isLoading: !1,
          data: m
        }
      });
    case D.CreateGroup:
      return Object.assign(Object.assign({}, e), {
        createdGroup: Object.assign(Object.assign({}, e.createdGroup), {
          isLoading: !0
        })
      });
    case D.CreateGroupError:
      return Object.assign(Object.assign({}, e), {
        createdGroup: {
          isLoading: !1,
          isError: C !== null,
          data: C
        }
      });
    case D.CreatedGroup:
      return Object.assign(Object.assign({}, e), {
        createdGroup: {
          isLoading: !1,
          isError: !1,
          data: C ?? null
        },
        // reset create-group form
        createGroupInput: {
          name: "",
          description: "",
          inputType: K.FileInput,
          fileUpload: null,
          textInput: ""
        },
        // reset group filters to fetch latest groups
        filters: Object.assign(Object.assign({}, e.filters), {
          searchType: "Group Name",
          sourceType: "All",
          viewType: "All",
          searchString: "",
          pageNumber: 0,
          totalPages: -1
        }),
        currentPage: J.ListGroups
      });
    case D.SetCreateGroupInput:
      return Object.assign(Object.assign({}, e), {
        createGroupInput: g
      });
    default:
      return e;
  }
}
function eo(e, t) {
  return Object.assign(Object.assign({}, e), Object.values(_e).includes(t.type) ? Jn(e, t) : Qn(e, t));
}
const to = JSON.parse('{"AeXO77":"Account","U3pytU":"Admin","fsBGk0":"Balance","paehRh":"Log Out","LcET2C":"Privacy Policy","vERlcd":"Profile","s+MGs7":"Resources","oyKamv":"Super Admin","3PpUfG":"Supplier View","XYLcNv":"Support","Sxm8rQ":"Users","wOSCp2":"Walmart Merchant View"}'), ro = JSON.parse('{"AeXO77":"Cuenta","U3pytU":"Administrador","fsBGk0":"Saldo","paehRh":"Cerrar sesión","LcET2C":"Política de Privacidad","vERlcd":"Perfil","s+MGs7":"Resources","oyKamv":"Super administrador","3PpUfG":"Vista del proveedor","XYLcNv":"Support","Sxm8rQ":"Usuarios","wOSCp2":"Vista del comprador de Walmart"}'), no = JSON.parse('{"AeXO77":"Compte","U3pytU":"Administrateur","fsBGk0":"Solde","paehRh":"Fermer la session","LcET2C":"Politique de protection des renseignements personnels","vERlcd":"Profil","s+MGs7":"Resources","oyKamv":"Super administrateur","3PpUfG":"Vue du fournisseur","XYLcNv":"Support","Sxm8rQ":"Utilisateurs","wOSCp2":"Vue du marchand Walmart"}');
Ce.load({
  "en-US": to,
  "es-MX": ro,
  "fr-CA": no
});
const oo = [
  {
    label: {
      id: "oyKamv"
    },
    value: "Super Admin",
    key: "superAdminPage",
    subLinks: [
      {
        label: {
          id: "wOSCp2"
        },
        value: "merchantView",
        key: "merchantViewPage",
        route: null
      },
      {
        label: {
          id: "3PpUfG"
        },
        value: "supplierView",
        key: "supplierViewPage",
        route: "/companyList",
        divider: !0
      }
    ]
  },
  {
    label: {
      id: "vERlcd"
    },
    value: "profile",
    key: "profilePage",
    route: "/profile",
    divider: !0,
    allowedDomains: [
      "WMT-US",
      "WMT-MX",
      "WMT-CA"
    ]
  },
  {
    label: {
      id: "U3pytU"
    },
    value: "admin",
    key: "adminPage",
    route: "/admin"
  },
  {
    label: {
      id: "Sxm8rQ"
    },
    value: "globalAdmin",
    key: "globalAdminPage",
    route: "/globalUserManagement"
  },
  {
    label: {
      id: "fsBGk0"
    },
    value: "balance",
    key: "balancePage",
    route: "/customerperception/balance",
    allowedDomains: [
      "WMT-US"
    ],
    useWindowOpen: !0
  },
  {
    label: {
      id: "paehRh"
    },
    value: "logOut",
    key: "logOut",
    route: "/logout",
    divider: !0
  },
  {
    label: {
      id: "LcET2C"
    },
    value: "privacy",
    key: "privacy",
    route: "/privacyPolicy",
    caption: !0,
    allowedDomains: [
      "WMT-US",
      "WMT-CA"
    ]
  }
], so = {
  id: "AeXO77"
}, se = {
  urlKey: {
    walmartLuminateApps: "WALMART_LUMINATE_APPS"
  },
  textValues: {
    accessCompletedStatus: "ACCESS_COMPLETE"
  },
  superAdmin: "Super Admin",
  superAdminSpectator: "Super Admin Spectator",
  basicVendor: "BASIC_VENDOR",
  adminRolePolicy: {
    listUser: {
      action: "LIST",
      resourceName: "USER"
    },
    listCompanyPartnerAssociation: {
      action: "LIST",
      resourceName: "COMPANY_PARTNER_ASSOCIATION"
    },
    updateEmailDomain: {
      action: "UPDATE",
      resourceName: "EMAIL_DOMAIN"
    },
    listEmailDomain: {
      action: "LIST",
      resourceName: "EMAIL_DOMAIN"
    },
    listActivityLog: {
      action: "LIST",
      resourceName: "ACTIVITY_LOG"
    }
  },
  userRole: {
    usersManagementAccess: {
      action: "VIEW",
      resourceName: "GLOBAL_USER_MANAGEMENT"
    }
  },
  menuOptions: {
    resources: "resources",
    support: "support"
  }
}, ao = JSON.parse('{"nIq0Yf":"Data Dictionary","yWH3P0":"Knowledge Base","rwWjWg":"Release Notes","CKpXXL":"Support Tickets","RY8WhQ":"Training Materials"}'), io = JSON.parse('{"nIq0Yf":"Diccionario de datos","yWH3P0":"Base de conocimientos","rwWjWg":"Notas de la versión","CKpXXL":"Tickets de soporte","RY8WhQ":"Materiales de capacitación"}'), lo = JSON.parse(`{"nIq0Yf":"Dictionnaire de données","yWH3P0":"Base de connaissances","rwWjWg":"Notes de publication","CKpXXL":"Requêtes d'assistance","RY8WhQ":"Matériel de formation"}`);
Ce.load({
  "en-US": ao,
  "es-MX": io,
  "fr-CA": lo
});
const co = /* @__PURE__ */ new Map([
  [
    "WMT-US",
    "https://learn.walmartdataventures.com/app"
  ],
  [
    "WMT-MX",
    "https://learn.walmartdataventures.mx/app"
  ],
  [
    "WMT-CA",
    "https://learn.walmartdataventures.ca/app"
  ]
]), ir = [
  {
    label: {
      id: "yWH3P0"
    },
    value: "knowledgeBase",
    key: "knowledgeBase",
    route: "/knowledgeBase/home",
    externalPath: !1,
    allowedDomains: [
      "WMT-US",
      "WMT-MX",
      "WMT-CA"
    ],
    allowedBasicUser: !0
  },
  {
    label: {
      id: "RY8WhQ"
    },
    value: "trainingMaterials",
    key: "trainingMaterials",
    route: "https://learn.walmartdataventures.com/app",
    externalPath: !0,
    allowedDomains: [
      "WMT-US",
      "WMT-MX",
      "WMT-CA"
    ],
    allowedBasicUser: !0
  },
  {
    label: {
      id: "nIq0Yf"
    },
    value: "dataDictionary",
    key: "dataDictionary",
    route: "/dataDictionary",
    externalPath: !1,
    allowedDomains: [
      "WMT-US",
      "WMT-MX",
      "WMT-CA"
    ],
    allowedBasicUser: !0
  },
  {
    label: {
      id: "CKpXXL"
    },
    value: "supportTickets",
    key: "supportTickets",
    route: "/support",
    externalPath: !1,
    allowedDomains: [
      "WMT-US",
      "WMT-MX",
      "WMT-CA"
    ]
  },
  {
    label: {
      id: "rwWjWg"
    },
    value: "releaseNotes",
    key: "releaseNotes",
    route: "/releaseNotes",
    externalPath: !1,
    allowedDomains: [
      "WMT-US"
    ]
  }
], uo = (e, t) => e.map((n) => {
  const r = t.find((o) => o.id === n.product_id);
  return Object.assign(Object.assign({}, r), {
    accessStatus: n.access_status,
    redirectUrl: r == null ? void 0 : r.redirectUrls
  });
}), po = (e) => {
  const t = e.permissions.map((n) => Object.assign(Object.assign({}, n), {
    resourceName: n.resource
  }));
  return {
    group: e.group,
    permissions: t
  };
}, ho = (e, t) => {
  const { accessCompletedStatus: n } = se.textValues, { externalAccessProducts: r } = h, o = new Map(t.map((s) => [
    s.code,
    s.restricted_launch_flag
  ]));
  return e.filter((s) => n === s.accessStatus).map((s) => {
    var { code: i, name: l } = s, d = Xe(s, [
      "code",
      "name"
    ]);
    return Object.assign({
      key: i,
      label: l,
      value: l,
      flag: o.get(i),
      externalAccess: r.includes(i)
    }, d);
  });
}, go = (e) => {
  var t, n, r, o, s, i, l, d, m, g;
  let C = [
    ...oo
  ];
  const S = V.getCurrentApplicationHostInfo().currentDomain, { CUSTOMER_PERCEPTION_RESOURCE: u, BALANCE: v, SUPER_ADMIN: N, SUPER_ADMIN_SPECTATOR: A, GLOBAL_ADMIN: k, ADMIN: P } = h, w = (t = e == null ? void 0 : e.products) === null || t === void 0 ? void 0 : t.some(({ code: p }) => p === u && !(e != null && e.thirdPartyUser)), E = ((n = e == null ? void 0 : e.authz) === null || n === void 0 ? void 0 : n.group) === N.group || ((r = e == null ? void 0 : e.authz) === null || r === void 0 ? void 0 : r.group) === A.group;
  return C = C.filter((p) => !p.allowedDomains || p.allowedDomains.includes(S)), E || (C = C.filter((p) => !(p.value === N.group || p.value === A.group))), (Array.isArray((o = e == null ? void 0 : e.authz) === null || o === void 0 ? void 0 : o.permissions) && !(!((s = e == null ? void 0 : e.authz) === null || s === void 0) && s.permissions.find(({ action: p, resourceName: _ }) => p === se.userRole.usersManagementAccess.action && _ === se.userRole.usersManagementAccess.resourceName || p === se.adminRolePolicy.listUser.action && _ === se.adminRolePolicy.listUser.resourceName || p === se.adminRolePolicy.listEmailDomain.action && _ === se.adminRolePolicy.listEmailDomain.resourceName || p === se.adminRolePolicy.listCompanyPartnerAssociation.action && _ === se.adminRolePolicy.listCompanyPartnerAssociation.resourceName || p === se.adminRolePolicy.listActivityLog.action && _ === se.adminRolePolicy.listActivityLog.resourceName)) || !(((l = (i = e == null ? void 0 : e.authz) === null || i === void 0 ? void 0 : i.permissions) === null || l === void 0 ? void 0 : l.length) > 0)) && (C = C.filter((p) => p.value !== P)), (Array.isArray((d = e == null ? void 0 : e.authz) === null || d === void 0 ? void 0 : d.permissions) && !e.authz.permissions.find(({ action: p, resourceName: _ }) => p === se.userRole.usersManagementAccess.action && _ === se.userRole.usersManagementAccess.resourceName) || !(((g = (m = e == null ? void 0 : e.authz) === null || m === void 0 ? void 0 : m.permissions) === null || g === void 0 ? void 0 : g.length) > 0)) && (C = C.filter((p) => p.value !== k)), w || (C = C.filter((p) => p.value !== v)), C;
}, mo = (e) => {
  let t = [
    ...ir
  ];
  if ((e == null ? void 0 : e.companyType) === h.BASIC_VENDOR) {
    t = t.filter((s) => s.allowedBasicUser);
    const o = t.find((s) => s.key === "knowledgeBase");
    o && (o.route = h.ROUTES.BASIC_USER_KB);
  }
  const n = V.getCurrentApplicationHostInfo().currentDomain || h.domains[h.hosts.us], r = t.find((o) => o.key === "trainingMaterials");
  return r && (r.route = co.get(n)), t;
}, ye = () => {
  const { _: e } = Gr();
  return {
    _: (t) => {
      if (isNaN(t)) {
        if (t)
          return e(t);
      } else return t;
      return "";
    }
  };
}, { hosts: lr, domains: fo, URLS: vo } = h, cr = window.location, _t = cr.origin, _o = cr.host, ur = Object.values(lr), pt = ur.find((e) => _t.includes(e));
let Ve = null;
const dr = (e = null) => {
  Ve = Ve === null ? e : Ve;
  const t = pt ? _t : Ve || "https://www.scintilla.com", n = fo[pt || lr.us];
  return {
    applicationOrigin: t,
    stateOfOrigin: pt,
    allowedHosts: ur,
    currentOrigin: _t,
    currentHost: _o,
    currentDomain: n
  };
}, At = ({ key: e, apiURL: t = "baseURL", customEnvironment: n }) => {
  const { applicationOrigin: r } = dr(n);
  return r && t ? `${r}${e ? vo[e] : ""}` : "";
};
function Co(e, t) {
  let n;
  function r(...o) {
    window.clearTimeout(n), n = window.setTimeout(() => {
      e(...o);
    }, t);
  }
  return r.cancel = () => {
    window.clearTimeout(n);
  }, r;
}
function yo(e, t) {
  return t.includes(e) || // Handle prefix Zeros on invalid UPCs
  t.find((n) => {
    const r = n.indexOf(e);
    return r > -1 && r + e.length === n.length && Array.from({
      length: r
    }).fill(0).join("") === n.substring(0, r);
  });
}
function So(e) {
  const t = document.createElement("div");
  return t.innerHTML = e, t.innerText;
}
const Eo = (e = `/login?lastUrl=${window.location.pathname}${window.location.search}`) => {
  window.location.replace(`${At({})}${e}`);
};
function To(e) {
  if (e === 0) return "0 Bytes";
  const t = 1024, n = [
    "Bytes",
    "KB",
    "MB",
    "GB"
  ], r = Math.floor(Math.log(e) / Math.log(t));
  return parseFloat((e / Math.pow(t, r)).toFixed(2)) + " " + n[r];
}
const bo = (e, t) => {
  const n = `${At({
    apiURL: "baseURL"
  })}${e}`;
  t ? window.open(n, "_blank") : window.location.replace(n);
}, Ao = (e) => e && h.ALLOWED_LOCALE_VALUES.includes(e) ? e : h.DEFAULT_LOCALE, Io = (e) => {
  var t, n;
  const { _: r } = ye();
  let o = {
    bannerId: "",
    validBannerMessage: ""
  };
  return e && ((t = e == null ? void 0 : e.authz) === null || t === void 0 ? void 0 : t.group) === h.SUPER_ADMIN_SPECTATOR.group ? o = {
    bannerId: h.SUPER_ADMIN_SPECTATOR.bannerID,
    validBannerMessage: r(h.SUPER_ADMIN_SPECTATOR.validBannerMessage)
  } : e && hr(e) ? o = {
    bannerId: h.THIRD_PARTY_SPONSORED_SUPPLIER.bannerID,
    validBannerMessage: r(h.THIRD_PARTY_SPONSORED_SUPPLIER.validBannerMessage)
  } : (((n = e == null ? void 0 : e.authz) === null || n === void 0 ? void 0 : n.group) === h.SUPER_ADMIN.group || Je(e)) && (o = {
    bannerId: h.SUPER_ADMIN.bannerID,
    validBannerMessage: r(h.SUPER_ADMIN.validBannerMessage)
  }), o;
}, Je = (e) => {
  var t;
  return Array.isArray((t = e == null ? void 0 : e.authz) === null || t === void 0 ? void 0 : t.permissions) && e.authz.permissions.filter((n) => n.action === h.switchCompanyPermission.action && n.resourceName === h.switchCompanyPermission.resourceName)[0] || !1;
}, No = (e) => {
  const t = Je(e), n = pr(e);
  return t && !n;
}, wo = (e) => {
  const t = Je(e), n = pr(e);
  return t && n;
}, pr = (e) => (e == null ? void 0 : e.companyType) !== h.UNKNOWN_COMPANY_VALUES, hr = (e) => (e == null ? void 0 : e.thirdPartyUser) && (e == null ? void 0 : e.userType) === "EXTERNAL" && (e == null ? void 0 : e.accessClass) === jr.MULTIPLE_TENANTS, Oo = (e) => {
  var t;
  const n = (t = e == null ? void 0 : e.authz) === null || t === void 0 ? void 0 : t.group;
  return n === h.SUPER_ADMIN.group || n === h.SUPER_ADMIN_SPECTATOR.group;
}, Lo = (e) => {
  var t;
  const n = (t = e == null ? void 0 : e.authz) === null || t === void 0 ? void 0 : t.permissions;
  if (Array.isArray(n) && n.length > 0) {
    const r = n.filter((s) => s.action === h.switchCompanyPermission.action && s.resourceName === h.switchCompanyPermission.resourceName)[0];
    return n.filter((s) => s.action === h.switchPersonaPermission.action && s.resourceName === h.switchPersonaPermission.resourceName)[0] ? r ? "Supplier" : "Merchant" : !1;
  }
  return !1;
}, Mo = (e) => {
  const r = document.cookie.split(";").filter((o) => o.split("=")[0].trim() === e);
  return r.length > 0 ? r[0].split("=")[1] : null;
}, Po = (e, t) => {
  const { first_name: n, last_name: r, login_id: o, email_address: s, user_type: i, tenant: l, user_preferences: d, third_party_user: m, site_id: g, products: C, authz: S, access_class: u } = e, v = Xe(e, [
    "first_name",
    "last_name",
    "login_id",
    "email_address",
    "user_type",
    "tenant",
    "user_preferences",
    "third_party_user",
    "site_id",
    "products",
    "authz",
    "access_class"
  ]);
  return Object.assign(Object.assign({}, v), {
    firstName: n,
    lastName: r,
    loginId: o,
    email: s,
    userType: i,
    company_id: l.id,
    timezone: d.locale.timezone,
    locale: `${d.language_code}`,
    companyName: l.name,
    thirdPartyUser: m,
    companyType: l.type,
    tenantId: g,
    products: uo(C, t),
    authz: po(S),
    accessClass: u
  });
}, V = {
  getCurrentApplicationHostInfo: dr,
  getAPIURL: At,
  debounce: Co,
  isUPCFound: yo,
  parseHtmlText: So,
  parseFileSize: To,
  logoutUser: bo,
  redirectionOnUnauthorized: Eo,
  validateLocale: Ao,
  getBannerDetails: Io,
  checkForCompanySwitchUser: Je,
  check3pSponsoredSupplier: hr,
  checkForSuperAdmin: Oo,
  getSuperAdminPersonaType: Lo,
  checkForCompanySwitchUserWithUnknownCompany: No,
  checkForCompanySwitchUserWithTaggedCompany: wo,
  readCookie: Mo,
  mapContextToUserInfoObj: Po
}, Ro = {
  POST: !0,
  PUT: !0,
  PATCH: !0,
  DELETE: !0,
  GET: !0
}, Uo = {
  200: !0
};
class oe {
  static httpRequest(t, n = {}, r = h.httpMethods.HTTP_METHODS.GET, o = h.httpMethods.HTTP_REQ_DEFAULT_HEADERS, s = !1, i = "json") {
    return new Promise((l, d) => {
      const m = JSON.stringify(n);
      let g = {};
      Ro[r] && !s && (g = {
        data: m
      }), s && (g = {
        data: n
      });
      const C = Object.assign({}, o);
      xr(Object.assign({
        url: t,
        method: r,
        headers: C,
        responseType: i
      }, g)).then((S) => {
        const { status: u, data: v } = S;
        Uo[u] ? l(v || {
          message: "Success"
        }) : d(h.httpMethods.HTTP_REQ_ERROR_MAP[u] || {
          status: u,
          errorMessage: v.error.message || z.DEFAULT_ERROR_MESSAGE
        });
      }, (S) => {
        const u = S.response && S.response.data || S.toJSON && S.toJSON() || {}, v = S.toJSON && S.toJSON() || {};
        d(Object.assign(Object.assign({}, u), {
          status: u.status || v.status || 404,
          errorMessage: S.message
        }));
      });
    });
  }
}
const It = (e, t = 0) => {
  let n;
  const r = [];
  return (...o) => new Promise((s, i) => {
    clearTimeout(n), n = setTimeout(() => {
      const l = [
        ...r
      ];
      r.length = 0, Promise.resolve(e.apply(void 0, o)).then((d) => {
        l.forEach(({ resolve: m }) => m(d));
      }, (d) => {
        l.forEach(({ reject: m }) => m(d));
      });
    }, t), r.push({
      resolve: s,
      reject: i
    });
  });
}, Go = () => {
  const e = {};
  return oe.httpRequest(`${V.getAPIURL({
    key: h.URL_KEY.IDENTITY_SITE
  })}`, {
    fetch_header_siteid: !0
  }, h.httpMethods.HTTP_METHODS.GET, e);
}, Do = It(Go, 100), gr = () => {
  const e = (r = null, o = !1) => {
    const s = localStorage.getItem("dataventures_locale_indicator");
    return o && s ? s : r && r !== s ? (localStorage.setItem("dataventures_locale_indicator", r), r) : s || t();
  }, t = () => h.DEFAULT_LOCALE;
  return {
    getLanguage: (...r) => ee(void 0, [
      ...r
    ], void 0, function* (o = null) {
      if (!o)
        return e();
      if (o.language)
        return e(o.language);
      try {
        const s = yield Wo(), { result: i } = yield jo();
        if (s) {
          const l = V.mapContextToUserInfoObj(s, i);
          return e(l.locale);
        } else
          return e();
      } catch {
        try {
          const i = yield Do();
          return i != null && i.default_language_code ? e(i.default_language_code, !0) : e();
        } catch {
          return e();
        }
      }
    }),
    defaultLanguage: t
  };
}, He = (e) => {
  const t = gr();
  return t.getLanguage().then((n) => {
    const r = V.validateLocale(n);
    Ce.activate(r);
  }).catch((n) => {
    console.log("*** Locale call failure ** ", n), Ce.activate(t.defaultLanguage());
  }), function(r) {
    return a(Dr, {
      i18n: Ce,
      children: a(e, Object.assign({}, r))
    });
  };
}, xo = (e, t) => {
  const n = Object.assign(Object.assign({}, h.httpMethods.HTTP_REQ_DEFAULT_HEADERS), {
    "Content-Type": "application/json;charset=UTF-8",
    "Context-App-Name": t
  }), r = `${V.getAPIURL({
    key: h.URL_KEY.CREATE_CUSTOM_GROUPS
  })}`;
  return oe.httpRequest(r, e, h.httpMethods.HTTP_METHODS.POST, n);
}, ko = (e, t) => {
  const { groupName: n, description: r, file: o } = e, s = Object.assign(Object.assign({}, h.httpMethods.HTTP_REQ_DEFAULT_HEADERS), {
    "Content-Type": "multipart/form-data",
    "Context-App-Name": t
  }), i = `${V.getAPIURL({
    key: h.URL_KEY.CREATE_CUSTOM_GROUPS_FROM_FILE
  })}?groupName=${encodeURIComponent(n)}&description=${encodeURIComponent(r)}`;
  return oe.httpRequest(i, o ? {
    file: o
  } : {}, h.httpMethods.HTTP_METHODS.POST, s, !0);
}, Ho = (e, t) => {
  const n = Object.assign(Object.assign({}, h.httpMethods.HTTP_REQ_DEFAULT_HEADERS), {
    "Content-Type": "application/json;",
    "Context-App-Name": t
  }), r = `${V.getAPIURL({
    key: h.URL_KEY.FAVOURITE_UPC
  })}`;
  return oe.httpRequest(r, e, h.httpMethods.HTTP_METHODS.POST, n);
}, Bo = (e, t) => {
  const n = Object.assign(Object.assign({}, h.httpMethods.HTTP_REQ_DEFAULT_HEADERS), {
    "Content-Type": "application/json",
    "Context-App-Name": t
  }), r = `${V.getAPIURL({
    key: h.URL_KEY.GET_CUSTOM_GROUPS
  })}`, o = zo(e), s = r + o;
  return oe.httpRequest(s, {}, h.httpMethods.HTTP_METHODS.GET, n);
}, Fo = (e, t, n) => {
  var r, o;
  const s = Object.assign(Object.assign({}, h.httpMethods.HTTP_REQ_DEFAULT_HEADERS), {
    "Content-Type": "application/json",
    "Context-App-Name": t
  }), i = `${V.getAPIURL({
    key: h.URL_KEY.GET_CUSTOM_GROUP_BY_TEXT
  })}`, l = `?text=${(r = e.text) !== null && r !== void 0 ? r : ""}&type=${(o = e.type) !== null && o !== void 0 ? o : ""}&source=${e.source}&view=${e.view}`, d = i + l;
  return oe.httpRequest(d, n, h.httpMethods.HTTP_METHODS.POST, s);
}, mr = (e, t) => {
  const n = Object.assign(Object.assign({}, h.httpMethods.HTTP_REQ_DEFAULT_HEADERS), {
    "Content-Type": "application/json",
    "Context-App-Name": t
  }), r = `${V.getAPIURL({
    key: h.URL_KEY.GET_GROUP_DETAILS_BY_ID
  })}`;
  return oe.httpRequest(r + `/${e}`, {}, h.httpMethods.HTTP_METHODS.GET, n);
}, Vo = (e) => {
  const t = Object.assign(Object.assign({}, h.httpMethods.HTTP_REQ_DEFAULT_HEADERS), {
    "Content-Type": h.httpMethods.CONTENT_TYPE.octetStream,
    "Context-App-Name": e
  });
  return oe.httpRequest(`${V.getAPIURL({
    key: h.URL_KEY.DOWNLOAD_FILE
  })}`, {}, h.httpMethods.HTTP_METHODS.GET, t, !1, "blob");
}, Nt = () => {
  const e = Object.assign(Object.assign({}, h.httpMethods.HTTP_REQ_DEFAULT_HEADERS), {
    "Content-Type": "application/json",
    "Context-App-Name": ""
  });
  return oe.httpRequest(`${V.getAPIURL({
    key: h.URL_KEY.USER_INFO
  })}?permissions=true`, {}, h.httpMethods.HTTP_METHODS.GET, e);
}, Wo = It(Nt, 100), $o = () => oe.httpRequest(`${V.getAPIURL({
  key: h.URL_KEY.SWITCH_CONTEXT
})}`), wt = () => oe.httpRequest(`${V.getAPIURL({
  key: h.URL_KEY.PRODUCTS
})}`), jo = It(wt, 100);
function zo(e) {
  return `?sortBy=${e.sortBy ? e.sortBy : ""}
        &sortOrder=${e.sortOrder ? e.sortOrder : "desc"}
        &page=${e.page !== void 0 ? e.page : 0}
        &pageSize=${e.pageSize !== void 0 ? e.pageSize : 50}`.replace(/\s/g, "");
}
const fr = /* @__PURE__ */ y.createContext(null), vr = /* @__PURE__ */ y.createContext(null), ie = () => {
  const e = y.useContext(fr);
  if (!e)
    throw new Error("Component must be inside Groups");
  return e;
}, be = () => {
  const e = y.useContext(vr);
  if (!e)
    throw new Error("Component must be inside Groups");
  return e;
}, qo = {
  // Added an id that is already present in db
  groupId: "0166610f-5ecc-41d6-8bc5-90419d487607",
  groupName: "Test Group",
  path: "",
  updatedOn: `${(/* @__PURE__ */ new Date()).getTime()}`,
  creator: ""
}, Yo = ({ children: e, componentName: t, maxSelectableGroups: n, defaultSelectedGroups: r }) => {
  var o;
  const [s, i] = y.useReducer(eo, {
    componentName: t,
    groups: {
      isLoading: !0,
      isError: !1,
      // Initialized to test data to show loader in Table component
      data: [
        qo
      ]
    },
    filters: {
      searchType: "Group Name",
      sourceType: "All",
      viewType: r != null && r.length ? "Selected" : "All",
      searchString: "",
      attribute: "groupName",
      order: "none",
      pageNumber: 0,
      totalPages: -1,
      last: !1
    },
    defaultSelectedGroups: r ?? [],
    selectedGroups: (o = r == null ? void 0 : r.map((C) => ({
      id: C,
      name: ""
    }))) !== null && o !== void 0 ? o : [],
    favouriteGroups: [],
    currentPage: J.ListGroups,
    selectedGroup: null,
    currentGroup: {
      isLoading: !1,
      isError: !1,
      data: {
        customGroupDetail: {
          groupId: "",
          groupName: "",
          createdUser: "",
          description: "",
          groupType: "",
          contextApp: "",
          path: ""
        },
        elements: [],
        invalidItems: []
      }
    },
    createGroupInput: {
      name: "",
      description: "",
      inputType: K.TextInput,
      textInput: "",
      fileUpload: null
    },
    createdGroup: {
      isLoading: !1,
      isError: !1,
      data: {
        result: {},
        requestId: ""
      }
    }
  }), { selectedGroup: l, currentPage: d } = s, m = y.useRef(""), g = y.useCallback(() => {
    ee(void 0, void 0, void 0, function* () {
      i({
        type: D.GetGroup
      });
      try {
        const { result: C } = yield mr(l.groupId, t);
        i({
          type: D.SetGroup,
          payload: {
            currentGroup: C
          }
        });
      } catch {
        i({
          type: D.GetGroupError
        });
      }
    });
  }, [
    l
  ]);
  return y.useEffect(() => {
    d === J.GroupDetails && (l == null ? void 0 : l.groupId) !== m.current && (m.current = l.groupId, g());
  }, [
    d,
    l
  ]), a(fr.Provider, {
    value: Object.assign(Object.assign({}, s), {
      maxSelectableGroups: n,
      componentName: t
    }),
    children: a(vr.Provider, {
      value: i,
      children: e
    })
  });
}, Ko = "_customGroups_3f7w1_1", Zo = "_actionButtons_3f7w1_5", Xo = "_actionBtnPopover_3f7w1_10", Jo = "_favouriteFill_3f7w1_15", Qo = "_footerActions_3f7w1_19", es = "_modalHeader_3f7w1_29", ts = "_headerTile_3f7w1_32", rs = "_headerTitleLabel_3f7w1_38", ns = "_headerTitleHint_3f7w1_42", os = "_container_3f7w1_48", ss = "_containerHeader_3f7w1_55", as = "_containerBody_3f7w1_67", is = "_field_3f7w1_71", ls = "_label_3f7w1_76", cs = "_breakWord_3f7w1_81", us = "_groupsListHeader_3f7w1_85", ds = "_groupsList_3f7w1_85", ps = "_filters_3f7w1_96", hs = "_groupSearchContainer_3f7w1_110", gs = "_groupSearchType_3f7w1_115", ms = "_sourceType_3f7w1_116", fs = "_viewType_3f7w1_117", vs = "_groupSearch_3f7w1_110", _s = "_customBtn_3f7w1_129", Cs = "_groupDetails_3f7w1_150", ys = "_groupInfo_3f7w1_155", Ss = "_groupValues_3f7w1_160", Es = "_groupItemId_3f7w1_164", Ts = "_invalid_3f7w1_169", bs = "_valid_3f7w1_172", As = "_spinnerContainer_3f7w1_195", Is = "_modalFooter_3f7w1_202", Ns = "_maxSelectionLimitReached_3f7w1_202", ws = "_formInput_3f7w1_208", Os = "_createGroupInput_3f7w1_218", Ls = "_createGroupHeader_3f7w1_218", Ms = "_inputOptions_3f7w1_227", Ps = "_createGroupBody_3f7w1_231", Rs = "_errorUpc_3f7w1_237", Us = "_textInput_3f7w1_240", Gs = "_fileUploadContainer_3f7w1_248", Ds = "_downloadTemplate_3f7w1_251", xs = "_fileUpload_3f7w1_248", ks = "_dragEnter_3f7w1_271", Hs = "_nativeFileInput_3f7w1_279", Bs = "_subText_3f7w1_297", Fs = "_iconContainer_3f7w1_310", Vs = "_fileContainer_3f7w1_311", Ws = "_fileDetails_3f7w1_342", $s = "_bareAlert_3f7w1_364", js = "_error_3f7w1_237", zs = "_actions_3f7w1_376", M = {
  customGroups: Ko,
  actionButtons: Zo,
  actionBtnPopover: Xo,
  favouriteFill: Jo,
  footerActions: Qo,
  modalHeader: es,
  headerTile: ts,
  headerTitleLabel: rs,
  headerTitleHint: ns,
  container: os,
  containerHeader: ss,
  containerBody: as,
  field: is,
  label: ls,
  breakWord: cs,
  groupsListHeader: us,
  groupsList: ds,
  filters: ps,
  groupSearchContainer: hs,
  groupSearchType: gs,
  sourceType: ms,
  viewType: fs,
  groupSearch: vs,
  customBtn: _s,
  groupDetails: Cs,
  groupInfo: ys,
  groupValues: Ss,
  groupItemId: Es,
  invalid: Ts,
  valid: bs,
  spinnerContainer: As,
  modalFooter: Is,
  maxSelectionLimitReached: Ns,
  formInput: ws,
  createGroupInput: Os,
  createGroupHeader: Ls,
  inputOptions: Ms,
  createGroupBody: Ps,
  errorUpc: Rs,
  textInput: Us,
  fileUploadContainer: Gs,
  downloadTemplate: Ds,
  fileUpload: xs,
  dragEnter: ks,
  nativeFileInput: Hs,
  subText: Bs,
  iconContainer: Fs,
  fileContainer: Vs,
  fileDetails: Ws,
  bareAlert: $s,
  error: js,
  actions: zs
}, qs = () => {
  const { maxSelectableGroups: e } = ie(), { labels: t } = h;
  return a("section", {
    className: [
      M.modalHeader,
      M.groupsListHeader
    ].join(" "),
    children: I("section", {
      className: M.headerTile,
      children: [
        a("div", {
          className: M.headerTitleLabel,
          children: t.selectProductGroup
        }),
        I("small", {
          className: M.headerTitleHint,
          children: [
            "Choose up to ",
            e,
            " custom groups"
          ]
        })
      ]
    })
  });
}, Ys = () => {
  const e = be(), { labels: t } = h;
  return a("section", {
    className: M.modalHeader,
    children: I("section", {
      className: M.headerTile,
      children: [
        a(Ye, {
          size: "medium",
          a11yLabel: "back to Groups list",
          onClick: () => e({
            type: D.SetCurrentPage,
            payload: {
              currentPage: J.ListGroups
            }
          }),
          children: a(de.ArrowLeft, {})
        }),
        a("div", {
          className: M.headerTitleLabel,
          children: t.groupDetails
        })
      ]
    })
  });
}, Ks = (e, t) => {
  const [n, r] = y.useState(0), [o, s] = y.useState([]), i = y.useRef(e), l = i.current.map((d) => d.groupId);
  return (e.length !== i.current.length || !e.map((d) => d.groupId).every((d) => l.includes(d))) && (i.current = e, r(0), s([])), y.useEffect(() => {
    let d;
    const m = t.current;
    if (m) {
      const g = {
        rootMargin: "100px"
      };
      d = new IntersectionObserver((C) => {
        const [{ isIntersecting: S }] = C;
        S && !o.includes(m) && (s((u) => [
          ...u,
          m
        ]), r((u) => u + 1));
      }, g), d.observe(m);
    }
    return () => {
      m && (d == null || d.unobserve(m));
    };
  }, [
    t.current,
    n,
    o
  ]), n;
}, Zs = () => {
  const { labels: e } = h, { componentName: t, groups: n, filters: r, selectedGroups: o } = ie(), s = be(), i = y.useRef(null), l = y.useRef(null), d = y.useRef(null), m = y.useRef(!1), g = y.useRef({
    SEARCH: "search",
    ALL: "all"
  }), C = y.useRef(""), S = y.useRef(0), u = y.useCallback(
    (P, w, E, p) => {
      s({
        type: D.GetGroups
      }), s({
        type: D.SetFilters,
        payload: {
          filters: Object.assign(Object.assign({}, r), {
            searchType: P,
            sourceType: w,
            viewType: E,
            searchString: p ? "" : r.searchString,
            pageNumber: 0
          })
        }
      }), m.current && (w === "All" && E === "All" && (p || r.searchString.length <= 3) ? A(0) : k.current(p ? "" : r.searchString, P, w, E, {
        productIds: E === "Selected" ? o.map((_) => _.id) : []
      }));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      s,
      r,
      o
    ]
  ), v = y.useCallback(
    (P = r.searchString) => {
      P.length > 3 ? k.current(P, r.searchType, r.sourceType, r.viewType, {
        productIds: r.viewType === "Selected" ? o.map((w) => w.id) : []
      }) : P.length === 0 ? u(r.searchType, r.sourceType, r.viewType, !0) : s({
        type: D.SetFilters,
        payload: {
          filters: Object.assign(Object.assign({}, r), {
            searchString: P,
            pageNumber: 0
          })
        }
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      r
    ]
  ), N = y.useCallback((P) => {
    var w, E;
    const p = (E = (w = P == null ? void 0 : P.target) === null || w === void 0 ? void 0 : w.value) !== null && E !== void 0 ? E : "";
    s({
      type: D.SetFilters,
      payload: {
        filters: Object.assign(Object.assign({}, r), {
          searchString: p,
          pageNumber: 0
        })
      }
    }), v(p);
  }, [
    r,
    s,
    v
  ]), A = y.useCallback(
    (P) => {
      ee(void 0, void 0, void 0, function* () {
        C.current = g.current.ALL;
        const w = P ?? r.pageNumber;
        try {
          s({
            type: D.GetGroups
          });
          const E = yield Bo({
            page: w,
            pageSize: 5e3
          }, t), { result: { content: p, totalPages: _ } } = E;
          S.current !== _ && (S.current = _), s({
            type: D.SetGroups,
            payload: {
              groups: [
                ...w > 0 ? n.data : [],
                ...p
              ]
            }
          });
        } catch {
          s({
            type: D.GetGroupsError
          });
        }
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      t,
      r.pageNumber
    ]
  ), k = y.useRef(V.debounce((P, w, E, p, _) => {
    ee(void 0, void 0, void 0, function* () {
      C.current = g.current.SEARCH, s({
        type: D.GetGroups
      });
      try {
        const U = yield Fo({
          text: encodeURIComponent(P),
          type: Dt[w],
          source: xt[E],
          view: kt[p]
        }, t, _), { result: B } = U;
        s({
          type: D.SetGroups,
          payload: {
            groups: B.content
          }
        });
      } catch {
        s({
          type: D.GetGroupsError
        });
      }
    });
  }, 300));
  return y.useEffect(() => {
    r.pageNumber > 0 && r.searchString.length === 0 && S.current > r.pageNumber && C.current === g.current.ALL && A();
  }, [
    r.pageNumber
  ]), y.useEffect(() => {
    m.current = !0, v();
  }, []), I("section", {
    className: M.filters,
    children: [
      I("div", {
        className: M.groupSearchContainer,
        children: [
          a(ct, {
            menuTrigger: a(ut, {
              ref: i,
              trailing: a(de.CaretDown, {}),
              "aria-pressed": void 0,
              children: r.searchType
            }),
            menuTriggerRef: i,
            options: Object.keys(Dt),
            preSelectedOptions: [
              r.searchType
            ],
            updateCheckedList: ([P]) => {
              u(P, r.sourceType, r.viewType, !1);
            },
            UNSAFE_className: M.groupSearchType,
            maxMenuHeight: "8.5rem"
          }),
          a(gt, {
            label: "",
            "aria-label": e.searchByText,
            size: "small",
            placeholder: "Search",
            leadingIcon: a(de.Search, {}),
            value: r.searchString,
            onChange: N,
            UNSAFE_className: M.groupSearch
          })
        ]
      }),
      I("div", {
        children: [
          a(ct, {
            menuTrigger: a(ut, {
              ref: l,
              trailing: a(de.CaretDown, {}),
              "aria-pressed": void 0,
              children: `${e.source}: ${r.sourceType}`
            }),
            menuTriggerRef: l,
            options: Object.keys(xt),
            preSelectedOptions: [
              r.sourceType
            ],
            updateCheckedList: ([P]) => {
              u(r.searchType, P, r.viewType, !1);
            },
            UNSAFE_className: M.sourceType
          }),
          a(ct, {
            menuTrigger: a(ut, {
              ref: d,
              trailing: a(de.CaretDown, {}),
              "aria-pressed": void 0,
              children: `${e.view}: ${r.viewType}`
            }),
            menuTriggerRef: d,
            options: Object.keys(kt),
            preSelectedOptions: [
              r.viewType
            ],
            updateCheckedList: ([P]) => {
              u(r.searchType, r.sourceType, P, !1);
            },
            UNSAFE_className: M.viewType
          })
        ]
      })
    ]
  });
}, _r = (e, t, n = !1) => {
  const [r, o] = y.useState(!0), [s, i] = y.useState(null), [l, d] = y.useState(null), { addSnack: m } = Wr();
  return y.useEffect(() => {
    t && ee(void 0, void 0, void 0, function* () {
      try {
        const C = yield Ho({
          groupId: t
        }, e);
        throw i(C), new Error("Test Error");
      } catch (C) {
        m({
          message: n ? z.removeFavouriteFailed : z.addFavouriteFailed
        }), d(C);
      } finally {
        o(!1);
      }
    });
  }, [
    t,
    n
  ]), {
    isProcessing: r,
    data: s,
    error: l
  };
}, Xs = ({
  group: e,
  toggleGroupSelection: t,
  // toggleFavouriteGroup,
  isLastRow: n,
  lastGroupRowRef: r
}) => {
  const { selectedGroups: o, maxSelectableGroups: s } = ie(), [i, l] = j(!1), d = y.useRef(null), m = o.map((g) => g.id);
  return a("div", {
    className: M.actionButtons,
    ref: n ? r : null,
    children: a(br, {
      content: a("div", {
        className: M.actionBtnPopover,
        children: `You reached the ${s}-group limit. You’ll need to deselect a group to select another.`
      }),
      position: "right",
      hasNubbin: !0,
      isOpen: i,
      onClose: () => l(!1),
      triggerRef: d,
      children: a(Ar, {
        ref: d,
        label: " ",
        "aria-label": "select-group",
        onChange: () => t(e),
        checked: m.includes(e.groupId),
        onMouseEnter: () => l(!m.includes(e.groupId) && m.length === s),
        onMouseLeave: () => {
          i && l(!1);
        },
        disabled: !m.includes(e.groupId) && o.length === s
      })
    })
  });
}, Js = () => {
  var e;
  const { labels: t } = h, { groups: { data: n, isLoading: r, isError: o }, filters: s, selectedGroups: i, favouriteGroups: l, defaultSelectedGroups: d, componentName: m } = ie(), g = be(), C = !r && !o && (n == null ? void 0 : n.length) === 0 ? z.NO_DATA_AVAILABLE : "", [S, u] = y.useState(!0), [v, N] = y.useState({
    groupId: "",
    unstar: !1
  }), A = y.useRef(null), k = y.useRef(d), P = Ks(n, A);
  _r(m, v.groupId, v.unstar), y.useEffect(() => {
    r || u(!1);
  }, [
    r
  ]), y.useEffect(() => {
    P > 0 && g({
      type: D.SetFilters,
      payload: {
        filters: Object.assign(Object.assign({}, s), {
          pageNumber: s.pageNumber + 1
        })
      }
    });
  }, [
    P,
    g
  ]), y.useEffect(() => {
    k.current = d;
  }, [
    d
  ]), y.useEffect(() => {
    if (i.some((_) => _.name.length === 0)) {
      const _ = n.reduce((U, B) => (U[B.groupId] = B.groupName, U), {});
      g({
        type: D.SetSelectedGroups,
        payload: {
          selectedGroups: i.map((U) => {
            var B;
            return U.name ? U : {
              id: U.id,
              name: (B = _[U.id]) !== null && B !== void 0 ? B : ""
            };
          })
        }
      });
    }
  }, [
    n
  ]), y.useEffect(() => {
    u(!0);
  }, []);
  const w = y.useCallback(
    (p) => {
      let _ = [];
      const U = i.findIndex((B) => B.id == p.groupId);
      U > -1 ? (k.current.length && (k.current = k.current.filter((B) => B !== p.groupId)), _ = [
        ...i.slice(0, U),
        ...i.slice(U + 1)
      ]) : _ = [
        ...i,
        {
          id: p.groupId,
          name: p.groupName
        }
      ], g({
        type: D.SetSelectedGroups,
        payload: {
          selectedGroups: _
        }
      }), _.length === 0 && s.viewType === "Selected" && g({
        type: D.SetFilters,
        payload: {
          filters: Object.assign(Object.assign({}, s), {
            viewType: "All"
          })
        }
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      i,
      s
    ]
  ), E = y.useCallback(
    (p) => {
      const _ = [
        ...l
      ], U = _.indexOf(p);
      U > -1 ? _.splice(U, 1) : _.push(p), g({
        type: D.SetFavouriteGroups,
        payload: {
          favouriteGroups: _
        }
      }), N({
        groupId: p,
        unstar: U > -1
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      l
    ]
  );
  return I("section", {
    className: M.groupsList,
    children: [
      a(Zs, {}),
      a(yt, {
        isLoading: S || r,
        emptyDataMessage: C,
        columns: [
          {
            columnIndex: 0,
            header: "",
            field: "",
            type: "custom",
            width: 50,
            fixedColumn: !0,
            customElement: (p) => {
              const _ = p;
              return a(Xs, {
                group: _,
                toggleGroupSelection: w,
                toggleFavouriteGroup: E,
                isLastRow: _.groupId === n[n.length - 1].groupId,
                lastGroupRowRef: A
              });
            }
          },
          {
            columnIndex: 1,
            header: t.groupName,
            field: "groupName",
            type: "custom",
            width: 150,
            customElement: (p) => {
              const _ = p;
              return a(ae, {
                variant: "tertiary",
                UNSAFE_className: M.customBtn,
                onClick: () => {
                  g({
                    type: D.SetCurrentPage,
                    payload: {
                      currentPage: J.GroupDetails,
                      selectedGroup: _
                    }
                  });
                },
                children: _ == null ? void 0 : _.groupName
              });
            }
          },
          {
            columnIndex: 2,
            header: t.path,
            field: "path",
            type: "alphanumeric",
            width: 175
          },
          {
            columnIndex: 3,
            header: t.creator,
            field: "creator",
            type: "alphanumeric",
            width: 175
          },
          {
            columnIndex: 4,
            header: t.lastEdit,
            field: "updatedOn",
            type: "alphanumeric",
            width: 75
          }
        ],
        data: (
          // to remove a group from list when de-selected
          s.viewType === "Selected" ? n.filter((p) => i.some((_) => _.id === p.groupId)).map((p) => Object.assign(Object.assign({}, p), {
            updatedOn: new Date(parseInt(p.updatedOn)).toLocaleDateString()
          })) : (e = n == null ? void 0 : n.map((p) => ({
            groupId: p.groupId,
            groupName: p.groupName,
            creator: p.creator,
            path: p.path,
            updatedOn: new Date(parseInt(p.updatedOn)).toLocaleDateString()
          }))) !== null && e !== void 0 ? e : []
        )
      })
    ]
  });
}, Qe = ({ children: e, title: t, className: n }) => I("div", {
  className: [
    M.containerHeader,
    n
  ].join(" "),
  children: [
    a("h2", {
      children: t
    }),
    e
  ]
}), et = ({ children: e, className: t }) => a("section", {
  className: [
    M.containerBody,
    t
  ].join(" "),
  children: e
}), tt = ({ children: e, className: t }) => a("section", {
  className: [
    M.container,
    t
  ].join(" "),
  children: e
}), Qs = () => {
  var e;
  const { currentGroup: { data: t, isError: n } } = ie(), { labels: r } = h;
  return !n && I(tt, {
    children: [
      a(Qe, {
        title: r.groupValues
      }),
      a(et, {
        className: M.groupValues,
        children: a(yt, {
          columns: [
            {
              columnIndex: 0,
              header: "UPC",
              field: "groupItem",
              type: "custom",
              width: 20,
              customElement: (o) => {
                var s;
                const i = o;
                return I("span", {
                  className: M.groupItemId,
                  children: [
                    !((s = t.invalidItems) === null || s === void 0) && s.includes(i.groupItem) ? a(de.CloseCircleFill, {
                      className: M.invalid
                    }) : a(de.CheckCircleFill, {
                      className: M.valid
                    }),
                    i.groupItem
                  ]
                });
              }
            },
            {
              columnIndex: 1,
              header: "Description",
              field: "name",
              type: "alphanumeric"
            }
          ],
          data: (e = t == null ? void 0 : t.elements) !== null && e !== void 0 ? e : []
        })
      })
    ]
  });
}, Vt = (e, t, n) => {
  const r = [], o = t.reduce((i, l) => {
    const d = Xe(l, [
      "groupUnitType",
      "attrName",
      "attrValues",
      "groupId",
      "groupName",
      "locus"
    ]), m = Object.keys(d).sort((C, S) => l[C].level - l[S].level), g = l[m[m.length - 1]].name;
    return g in i ? i[g].push({
      attribKeys: m,
      attrib: l
    }) : i[g] = [
      {
        attribKeys: m,
        attrib: l
      }
    ], i;
  }, {}), s = Object.keys(o).map((i) => {
    const l = [
      i
    ];
    return o[i].forEach((d) => {
      const m = [];
      for (let g = 0; g < d.attribKeys.length; g++)
        g === d.attribKeys.length - 1 ? m.push(a("strong", {
          children: d.attrib[d.attribKeys[d.attribKeys.length - 1]].desc
        })) : m.push(d.attrib[d.attribKeys[g]].desc);
      l.push(m.reduce((g, C, S) => I(X, {
        children: [
          g,
          S > 0 && " > ",
          C
        ]
      }), a(X, {})));
    }), l;
  });
  for (const i of s)
    r.push({
      type: e,
      condition: n,
      nodes: a("div", {
        children: i.map((l, d) => a("div", {
          children: l
        }, d))
      })
    });
  return r;
}, ea = (e) => {
  var t, n;
  const r = [];
  return !((t = e.include) === null || t === void 0) && t.length && r.push(...Vt(e.entity, e.include, "is in list")), !((n = e.exclude) === null || n === void 0) && n.length && r.push(...Vt(e.entity, e.exclude, "not in list")), r;
}, ta = (e) => {
  var t, n;
  const r = [];
  if (!((t = e.include) === null || t === void 0) && t.length) {
    const o = e.include.reduce((s, i) => (s.push(`${i.attrName} ${i.locus.operator === "NotEquals" ? "NOT IN" : "IN"}:`), s.push(i.attrValues.map((l) => l.value).join(", ")), s), []);
    r.push({
      type: e.entity,
      condition: "is in list",
      nodes: a("div", {
        children: o.map((s, i) => a("div", {
          children: s
        }, i))
      })
    });
  }
  if (!((n = e.exclude) === null || n === void 0) && n.length) {
    const o = e.exclude.reduce((s, i) => (s.push(`${i.attrName} ${i.locus.operator === "NotEquals" ? "NOT IN" : "IN"}:`), s.push(i.attrValues.map((l) => l.value).join(", ")), s), []);
    r.push({
      type: e.entity,
      condition: "not in list",
      nodes: a("div", {
        children: o.map((s, i) => a("div", {
          children: s
        }, i))
      })
    });
  }
  return r;
}, ra = (e, t) => ee(void 0, void 0, void 0, function* () {
  var n, r, o, s;
  const i = [], l = /* @__PURE__ */ new Set();
  !((n = e.include) === null || n === void 0) && n.length && e.include.forEach((g) => l.add(g.groupId)), !((r = e.exclude) === null || r === void 0) && r.length && e.exclude.forEach((g) => l.add(g.groupId));
  let d = [];
  try {
    d = yield Promise.all([
      ...l
    ].map((g) => mr(g, t)));
  } catch {
    console.error("Error fetching group details.");
  }
  const m = d.reduce((g, { result: { customGroupDetail: { groupId: C, groupName: S } } }) => (g[C] = S, g), {});
  if (!((o = e.include) === null || o === void 0) && o.length) {
    const g = e.include.map((C) => m[C.groupId]).join(", ");
    i.push({
      type: e.entity,
      condition: "is in list",
      nodes: a("div", {
        "data-testId": "custom_group-in_list",
        children: g.trim().length > 1 ? g : "-"
      })
    });
  }
  if (!((s = e.exclude) === null || s === void 0) && s.length) {
    const g = e.exclude.map((C) => m[C.groupId]).join(", ");
    i.push({
      type: e.entity,
      condition: "not in list",
      nodes: a("div", {
        "data-testId": "custom_group-not_in_list",
        children: g.trim().length > 1 ? g : "-"
      })
    });
  }
  return i;
}), na = () => {
  const { currentGroup: { data: e, isError: t }, componentName: n } = ie(), { labels: r } = h, [o, s] = y.useState([]), i = e.customGroupDetail.dynamicGroupDefinition;
  return y.useEffect(() => {
    if (i) {
      const l = [], d = i.ruleValues.reduce((m, g) => (g.entity === "Product_Hierarchy" ? m.productHeirarchy = g : g.entity === "Attribute" ? m.attribute = g : g.entity === "Custom_Group" && (m.customGroup = g), m), {});
      "productHeirarchy" in d && l.push(...ea(d.productHeirarchy)), "attribute" in d && l.push(...ta(d.attribute)), s(l), function() {
        return ee(this, void 0, void 0, function* () {
          "customGroup" in d && s([
            ...l,
            ...yield ra(d.customGroup, n)
          ]);
        });
      }();
    }
  }, []), i ? !t && I(tt, {
    children: [
      a(Qe, {
        title: r.groupValues
      }),
      a(et, {
        className: M.groupValues,
        children: a(yt, {
          columns: [
            {
              columnIndex: 0,
              header: "Type",
              field: "type",
              type: "alphanumeric"
            },
            {
              columnIndex: 1,
              header: "Condition",
              field: "condition",
              type: "alphanumeric"
            },
            {
              columnIndex: 2,
              header: "Selected nodes",
              field: "nodes",
              type: "alphanumeric"
            }
          ],
          data: o
        })
      })
    ]
  }) : null;
}, De = ({ label: e, value: t }) => {
  const { _: n } = ye(), r = /* @__PURE__ */ y.isValidElement(t);
  return I("div", {
    className: M.field,
    children: [
      I("span", {
        className: M.label,
        children: [
          n(e),
          ": "
        ]
      }),
      a("div", {
        className: M.breakWord,
        children: r || t
      })
    ]
  });
}, oa = () => {
  var e, t, n, r, o, s, i, l, d, m, g, C, S;
  const { currentGroup: { isLoading: u, data: v }, componentName: N } = ie(), [A, k] = y.useState({
    groupId: "",
    unstar: !1
  }), P = y.useRef(!1), { labels: w } = h, E = ((t = (e = v == null ? void 0 : v.customGroupDetail) === null || e === void 0 ? void 0 : e.groupType) === null || t === void 0 ? void 0 : t.trim()) === "D", p = ((n = v == null ? void 0 : v.customGroupDetail) === null || n === void 0 ? void 0 : n.contextApp) === "SHOPPER_BEHAVIOR" ? "Shopper Behavior" : h.SCINTILLA;
  return _r(N, A.groupId, A.unstar), u ? a("div", {
    className: M.spinnerContainer,
    children: a(Ir, {
      color: "gray",
      size: "large"
    })
  }) : (v && !P.current && (k({
    groupId: "",
    // TODO: Update this with the actual API
    unstar: !0
  }), P.current = !0), I("section", {
    className: M.groupDetails,
    children: [
      I(tt, {
        children: [
          a(Qe, {
            title: w.groupInfo
          }),
          I(et, {
            className: M.groupInfo,
            children: [
              a(De, {
                label: w.name,
                value: (o = (r = v == null ? void 0 : v.customGroupDetail) === null || r === void 0 ? void 0 : r.groupName) !== null && o !== void 0 ? o : ""
              }),
              a(De, {
                label: w.description,
                value: (i = (s = v == null ? void 0 : v.customGroupDetail) === null || s === void 0 ? void 0 : s.description) !== null && i !== void 0 ? i : ""
              }),
              a(De, {
                label: w.creator,
                value: (d = (l = v == null ? void 0 : v.customGroupDetail) === null || l === void 0 ? void 0 : l.createdUser) !== null && d !== void 0 ? d : ""
              }),
              a(De, {
                label: w.application,
                value: p
              }),
              ((g = (m = v == null ? void 0 : v.customGroupDetail) === null || m === void 0 ? void 0 : m.groupType) === null || g === void 0 ? void 0 : g.trim()) === "D" ? a(De, {
                label: w.path,
                value: (S = (C = v == null ? void 0 : v.customGroupDetail) === null || C === void 0 ? void 0 : C.path) !== null && S !== void 0 ? S : ""
              }) : null
            ]
          })
        ]
      }),
      E ? a(na, {}) : a(Qs, {})
    ]
  }));
}, sa = ({ onSelectedGroups: e }) => {
  const { labels: t } = h, n = be(), { maxSelectableGroups: r, selectedGroups: o } = ie();
  return I(Nr, {
    UNSAFE_className: M.footerActions,
    children: [
      I(ae, {
        size: "medium",
        variant: "secondary",
        onClick: () => {
          n({
            type: D.SetCurrentPage,
            payload: {
              currentPage: J.CreateGroup
            }
          }), n({
            type: _e.NewGroupButtonClicked,
            location: J.ListGroups
          });
        },
        children: [
          a(kr, {}),
          " ",
          a("span", {
            children: t.newGroup
          })
        ]
      }),
      I("div", {
        children: [
          a(ae, {
            size: "medium",
            variant: "secondary",
            disabled: o.length === 0,
            onClick: () => {
              n({
                type: D.ClearSelectedGroups
              });
            },
            children: a("span", {
              children: t.clearAll
            })
          }),
          I(ae, {
            onClick: () => {
              n({
                type: _e.GroupsSelectionApplied,
                location: J.ListGroups,
                payload: o.length
              }), window.setTimeout(() => {
                e(o);
              }, 1e3);
            },
            size: "medium",
            variant: "primary",
            children: [
              t.apply,
              " (",
              o.length,
              "/",
              r,
              ")"
            ]
          })
        ]
      })
    ]
  });
}, aa = () => {
  const { selectedGroups: e, selectedGroup: t, maxSelectableGroups: n } = ie(), r = be(), { labels: o } = h;
  let s = a(X, {});
  const i = e.findIndex((l) => l.id === (t == null ? void 0 : t.groupId));
  if (e.length >= n)
    s = a(St, {
      showCloseButton: !1,
      variant: "info",
      UNSAFE_className: M.maxSelectionLimitReached,
      children: z.MAX_SELECTION_LIMIT
    });
  else {
    const l = e.map((d) => d.id);
    s = a(ae, {
      disabled: i !== -1,
      onClick: () => {
        var d;
        return r({
          type: D.SetCurrentPage,
          payload: {
            selectedGroups: l.includes((d = t.groupId) !== null && d !== void 0 ? d : "") ? e : [
              ...e,
              {
                id: t.groupId,
                name: t.groupName
              }
            ],
            currentPage: J.ListGroups
          }
        });
      },
      size: "medium",
      variant: "primary",
      children: o.select
    });
  }
  return a("section", {
    className: M.modalFooter,
    children: s
  });
}, ia = () => {
  const e = be(), { labels: t } = h;
  return a("section", {
    className: M.modalHeader,
    children: I("section", {
      className: M.headerTile,
      children: [
        a(Ye, {
          size: "medium",
          a11yLabel: "back to Groups list",
          onClick: () => e({
            type: D.SetCurrentPage,
            payload: {
              currentPage: J.ListGroups
            }
          }),
          children: a(de.ArrowLeft, {})
        }),
        I("section", {
          children: [
            a("div", {
              className: M.headerTitleLabel,
              children: t.createGroup
            }),
            a("div", {
              className: M.headerTitleHint,
              children: t.createGroupHint
            })
          ]
        })
      ]
    })
  });
}, la = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='Size=Medium'%3e%3cpath%20id='attachment'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M15.8182%2016.8229C15.8182%2017.1045%2015.7601%2017.3819%2015.6313%2017.6322C15.1333%2018.5996%2013.6962%2021.0682%2012%2021.0682C9.89045%2021.0682%208.18182%2019.3595%208.18182%2017.25V5.31818C8.18182%204.00091%209.25091%202.93182%2010.5682%202.93182C11.8855%202.93182%2012.9545%204.00091%2012.9545%205.31818V15.3409C12.9545%2015.8659%2012.525%2016.2955%2012%2016.2955C11.475%2016.2955%2011.0455%2015.8659%2011.0455%2015.3409V7.02C11.0455%207.02%2011.0455%206.27273%2010.3462%206.27273C9.64693%206.27273%209.61364%207.02%209.61364%207.02V15.3409C9.61364%2016.6582%2010.6827%2017.7273%2012%2017.7273C13.3173%2017.7273%2014.3864%2016.6582%2014.3864%2015.3409V5.31818C14.3864%203.20864%2012.6777%201.5%2010.5682%201.5C8.45864%201.5%206.75%203.20864%206.75%205.31818V17.25C6.75%2020.1518%209.09818%2022.5%2012%2022.5C14.9018%2022.5%2017.25%2020.1518%2017.25%2017.25V7.02273C17.25%207.02273%2017.25%206.27273%2016.54%206.27273C15.83%206.27273%2015.8182%207.02273%2015.8182%207.02273V16.8229Z'%20fill='black'/%3e%3c/g%3e%3c/svg%3e";
var Ee;
(function(e) {
  e[e.Warning = 0] = "Warning", e[e.Error = 1] = "Error";
})(Ee || (Ee = {}));
const ca = ({ file: e, error: t = "", onDelete: n }) => {
  const { labels: r } = h;
  let o = t, s = Ee.Warning;
  return e.size / Kt > 1 && (o = z.fileExceedsLimit, s = Ee.Error), /(\.xlsx)$/i.exec(e.name) || (o = z.unsupportedFileType, s = Ee.Error), I("div", {
    className: [
      M.fileContainer,
      o.length > 0 && s === Ee.Error ? M.error : ""
    ].join(" "),
    children: [
      a("div", {
        className: M.iconContainer,
        children: a("img", {
          src: la,
          alt: "File Icon",
          role: "presentation"
        })
      }),
      I("div", {
        className: M.fileDetails,
        children: [
          a("span", {
            children: e.name
          }),
          I("div", {
            children: [
              !(o.length > 0) && I("span", {
                children: [
                  r.size,
                  ": ",
                  V.parseFileSize(e.size)
                ]
              }),
              o.length > 0 && a(St, {
                variant: s === Ee.Error ? "error" : "warning",
                a11yIconLabel: o,
                showCloseButton: !1,
                UNSAFE_className: M.bareAlert,
                children: o
              })
            ]
          })
        ]
      }),
      a("div", {
        className: M.actions,
        children: a(Ye, {
          onClick: n,
          a11yLabel: r.deleteFile,
          color: (s === Ee.Error, ""),
          children: a(de.TrashCan, {})
        })
      })
    ]
  });
}, ua = ({ onFileChange: e }) => {
  const { labels: t } = h, { componentName: n } = ie(), r = /* @__PURE__ */ y.createRef(), o = /* @__PURE__ */ y.createRef(), s = y.useRef({
    DragEnter: M.dragEnter
  }), i = y.useRef(!1), l = y.useRef(null), [d, m] = y.useState([]), [g, C] = y.useState(null), S = y.useCallback(() => ee(void 0, void 0, void 0, function* () {
    if (i.current)
      return !1;
    try {
      i.current = !0;
      let E;
      if (l.current)
        E = URL.createObjectURL(l.current);
      else {
        const _ = yield Vo(n);
        E = URL.createObjectURL(_), l.current = _;
      }
      const p = document.createElement("a");
      p.style.display = "none", p.href = E, p.download = "upc-template", document.body.appendChild(p), p.click(), window.URL.revokeObjectURL(E);
    } catch (E) {
      console.error("Failed to download template", E);
    } finally {
      i.current = !1;
    }
  }), [
    n
  ]), u = y.useCallback((E) => {
    E.preventDefault(), m([
      s.current.DragEnter
    ]);
  }, []), v = y.useCallback((E) => {
    E.preventDefault(), m((p) => p.filter((_) => _ !== s.current.DragEnter));
  }, []), N = y.useCallback((E) => {
    E.preventDefault(), d.includes(s.current.DragEnter) || m([
      s.current.DragEnter
    ]);
  }, [
    d
  ]), A = y.useCallback((E) => {
    if (E.preventDefault(), m([]), E.dataTransfer.items)
      for (const p of [
        ...E.dataTransfer.items
      ]) {
        if (p.kind === "file") {
          const _ = p.getAsFile();
          C(_);
        }
        break;
      }
    else
      C(E.dataTransfer.files[0]);
  }, []), k = (E) => {
    var p;
    const _ = (p = E.target.files) === null || p === void 0 ? void 0 : p[0];
    C(_ || null);
  }, P = () => {
    var E;
    (E = o.current) === null || E === void 0 || E.click();
  }, w = () => {
    C(null);
  };
  return y.useEffect(() => {
    e(g);
  }, [
    g
  ]), I("section", {
    className: M.fileUploadContainer,
    children: [
      g && a(ca, {
        file: g,
        onDelete: w
      }),
      !g && I(X, {
        children: [
          I("div", {
            className: M.downloadTemplate,
            children: [
              a(ae, {
                variant: "tertiary",
                onClick: S,
                children: t.downloadTemplate
              }),
              a("span", {
                children: t.downlodTemplateSuffix
              })
            ]
          }),
          I("div", {
            ref: r,
            onDragEnter: u,
            onDragOver: N,
            onDragLeave: v,
            onDrop: A,
            className: [
              M.fileUpload,
              ...d
            ].join(" "),
            children: [
              a("div", {
                className: M.iconContainer,
                children: a(de.CloudUpload, {})
              }),
              a("input", {
                type: "file",
                accept: ".xlsx",
                ref: o,
                onChange: k,
                className: M.nativeFileInput,
                draggable: !1
              }),
              a("span", {
                children: z.dragAndDropHere
              }),
              a(ae, {
                onClick: P,
                draggable: !1,
                children: t.chooseFile
              }),
              a("span", {
                className: M.subText,
                children: z.dragAndDropSubText
              })
            ]
          })
        ]
      })
    ]
  });
}, da = () => {
  var e;
  const { createdGroup: t, createGroupInput: { textInput: n } } = ie(), r = be(), { labels: o } = h, s = y.useRef(null), [i, l] = y.useState(""), [d, m] = y.useState(""), [g, C] = y.useState(""), [S, u] = y.useState(K.FileInput), [v, N] = y.useState(""), [A, k] = y.useState(null), P = (e = V.parseHtmlText(v)) !== null && e !== void 0 ? e : "";
  y.useEffect(() => {
    r({
      type: D.SetCreateGroupInput,
      payload: {
        createGroupInput: {
          name: i,
          description: g,
          inputType: S,
          textInput: P,
          fileUpload: A
        }
      }
    });
  }, [
    i,
    g,
    S,
    v,
    A
  ]), y.useEffect(() => {
    v && N(n);
  }, [
    n
  ]), y.useEffect(() => {
    var F;
    return (F = s.current) === null || F === void 0 || F.focus(), () => {
      E();
    };
  }, []);
  const w = y.useCallback((F) => {
    k(F), F || E();
  }, []), E = y.useCallback(() => {
    r({
      type: D.CreateGroupError,
      payload: {
        createdGroup: null
      }
    });
  }, [
    r
  ]), p = y.useCallback((F) => {
    u(F), S !== F && E();
  }, [
    S,
    E
  ]), _ = y.useCallback(() => {
    var F, c, f, T, b, G, R;
    let x = "", W = "error";
    if (t != null && t.data) {
      const { data: H } = t, L = (c = (F = H.result) === null || F === void 0 ? void 0 : F.invalidUpcs) !== null && c !== void 0 ? c : [];
      ((T = (f = H.result) === null || f === void 0 ? void 0 : f.validUpcDetails) !== null && T !== void 0 ? T : []).length === 0 && L.length > 0 ? x = z.noValidUPCItems : L.length > 0 ? (W = "warning", x = `Your input contains ${L.length} invalid ${L.length === 1 ? "ID" : "IDs"}. ${z.partialValidUPCItemsSuffix}
            ${L.join(", ")}`) : x = (R = (b = H.detail) !== null && b !== void 0 ? b : (G = H.error) === null || G === void 0 ? void 0 : G.message) !== null && R !== void 0 ? R : "";
    }
    return [
      x,
      W
    ];
  }, [
    t
  ]), U = () => S === K.TextInput ? a(wr, {
    label: "",
    "aria-label": `${o.textInput}-value`,
    placeholder: z.enterTextInput,
    onChange: (F) => N(F.target.value),
    value: v,
    size: "large"
  }) : a(ua, {
    onFileChange: w
  }), B = y.useCallback((F = i) => {
    let c = "";
    const f = F == null ? void 0 : F.trim().length;
    return f === 0 ? c = z.nameRequired : f < 5 && (c = z.nameMinLength), c;
  }, [
    i
  ]);
  let ce = a(X, {});
  if (t != null && t.isError && (t != null && t.data) && (S === K.TextInput || A)) {
    const [F, c] = _();
    ce = a(St, {
      variant: c,
      showCloseButton: !1,
      "data-testid": "upc-error-alert",
      children: F
    });
  }
  return I("section", {
    children: [
      I("section", {
        className: "",
        children: [
          I("div", {
            className: M.formInput,
            children: [
              a(gt, {
                ref: s,
                label: o.name,
                onChange: (F) => {
                  var c;
                  const f = (c = F.target.value) !== null && c !== void 0 ? c : "";
                  l(f), m(B(f));
                },
                placeholder: z.groupName,
                value: i,
                size: "small",
                type: "text",
                textFieldProps: {
                  minLength: 5,
                  maxLength: 100,
                  onBlur: () => m(B())
                },
                error: d
              }),
              I("span", {
                children: [
                  i.length,
                  "/100"
                ]
              })
            ]
          }),
          I("div", {
            className: M.formInput,
            children: [
              a(gt, {
                label: `${o.description} (${o.optional})`,
                onChange: (F) => C(F.target.value),
                value: g,
                placeholder: z.description,
                size: "small",
                type: "text",
                textFieldProps: {
                  maxLength: 240
                }
              }),
              I("span", {
                children: [
                  g.length,
                  "/240"
                ]
              })
            ]
          })
        ]
      }),
      a("section", {
        children: I(tt, {
          className: M.createGroupInput,
          children: [
            a(Qe, {
              title: o.groupValues,
              className: M.createGroupHeader,
              children: I("div", {
                className: M.inputOptions,
                children: [
                  a(Rt, {
                    name: "inputType",
                    checked: S === K.FileInput,
                    label: o.fileUpload,
                    onChange: () => p(K.FileInput)
                  }),
                  a(Rt, {
                    name: "inputType",
                    checked: S === K.TextInput,
                    label: o.textInput,
                    onChange: () => p(K.TextInput)
                  })
                ]
              })
            }),
            I(et, {
              className: M.createGroupBody,
              children: [
                ce,
                U()
              ]
            })
          ]
        })
      })
    ]
  });
}, pa = () => {
  var e, t, n, r, o, s;
  const { labels: i } = h, { componentName: l, createGroupInput: { name: d, description: m, inputType: g, textInput: C, fileUpload: S }, createdGroup: u } = ie(), v = be(), N = y.useRef(""), A = y.useRef(null), [k, P] = y.useState(!1);
  let w = C.split(",").map((b) => b.trim()).filter(Boolean);
  const E = N.current === C, p = A.current === S, _ = (n = (t = (e = u == null ? void 0 : u.data) === null || e === void 0 ? void 0 : e.result) === null || t === void 0 ? void 0 : t.invalidUpcs) !== null && n !== void 0 ? n : [], U = (s = (o = (r = u == null ? void 0 : u.data) === null || r === void 0 ? void 0 : r.result) === null || o === void 0 ? void 0 : o.validUpcDetails) !== null && s !== void 0 ? s : [];
  let B = !1, ce = !1;
  const F = d.trim().length;
  u.isLoading || F === 0 || F < 5 || g === K.TextInput && (w.length === 0 || E && _.length === w.length) || g === K.FileInput && (!S || u != null && u.isError && U.length === 0 && p || S.size > Kt || !/(\.xlsx)$/i.exec(S.name)) ? B = !0 : B = !1, u != null && u.isError && _.length > 0 && (g === K.TextInput && w.length > 0 || g === K.FileInput && p && U.length > 0) && (w.length > 0 ? (ce = !0, w = w.filter((b) => !V.isUPCFound(b, _))) : w = U.map((b) => b.upcId));
  const c = k && E, f = g === K.FileInput && p && k ? K.TextInput : g, T = () => ee(void 0, void 0, void 0, function* () {
    var b, G, R, x, W, H;
    ce && v({
      type: D.SetCreateGroupInput,
      payload: {
        createGroupInput: {
          name: d.trim().replace(/\s\s+/g, " "),
          description: m,
          inputType: g,
          fileUpload: S,
          textInput: w.join(", ")
        }
      }
    }), v({
      type: D.CreateGroup
    });
    try {
      let L;
      f === K.TextInput ? L = yield xo({
        groupName: d.trim().replace(/\s\s+/g, " "),
        description: m,
        elementsCategory: "UPC",
        groupType: "S",
        accessFlag: !0,
        elements: w,
        invalidElements: [],
        fileUpload: !1
      }, l) : S && (L = yield ko({
        file: S,
        groupName: d.trim().replace(/\s\s+/g, " "),
        description: m
      }, l)), v({
        type: D.CreatedGroup,
        payload: {
          createdGroup: L
        }
      });
    } catch (L) {
      N.current = C, A.current = S;
      const $ = L;
      ((R = (G = (b = $.result) === null || b === void 0 ? void 0 : b.invalidUpcs) === null || G === void 0 ? void 0 : G.length) !== null && R !== void 0 ? R : 0) > 0 && ((H = (W = (x = $.result) === null || x === void 0 ? void 0 : x.validUpcDetails) === null || W === void 0 ? void 0 : W.length) !== null && H !== void 0 ? H : 0) > 0 && P(!0), v({
        type: D.CreateGroupError,
        payload: {
          createdGroup: $
        }
      });
    }
  });
  return a("section", {
    className: M.modalFooter,
    children: a(ae, {
      onClick: () => {
        T(), v({
          type: _e.NewGroupCreationSubmitted,
          location: J.CreateGroup
        });
      },
      size: "medium",
      variant: "primary",
      disabled: B,
      children: c ? i.continue : i.create
    })
  });
}, ha = ({ onClose: e, onSelectedGroups: t }) => {
  const { currentPage: n } = ie();
  let r = a(X, {}), o = a(X, {}), s = a(X, {});
  switch (n) {
    case J.ListGroups:
      r = a(qs, {}), o = a(Js, {}), s = a(sa, {
        onSelectedGroups: t
      });
      break;
    case J.GroupDetails:
      r = a(Ys, {}), o = a(oa, {}), s = a(aa, {});
      break;
    case J.CreateGroup:
      r = a(ia, {}), o = a(da, {}), s = a(pa, {});
      break;
    default:
      r = a(X, {}), o = a(X, {}), s = a(X, {});
  }
  return a(zt, {
    isOpen: !0,
    actions: s,
    onClose: e,
    size: "mega",
    title: r,
    UNSAFE_className: M.customGroups,
    children: o
  });
}, ga = ({ maxSelectableGroups: e, componentName: t, onClose: n, onSelectedGroups: r, defaultSelectedGroups: o }) => a(Or, {
  children: a(Yo, {
    maxSelectableGroups: e,
    componentName: t,
    defaultSelectedGroups: o,
    children: a(ha, {
      onClose: n,
      onSelectedGroups: r
    })
  })
}), vl = He(ga), Ct = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20xmlns='http://www.w3.org/2000/svg'%20version='1.1'%20viewBox='0%200%202413.5%20615.5'%3e%3cdefs%3e%3cstyle%3e%20.cls-1%20{%20fill:%20%233c228a;%20}%20%3c/style%3e%3c/defs%3e%3c!--%20Generator:%20Adobe%20Illustrator%2028.7.1,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%201.2.0%20Build%20142)%20--%3e%3cg%3e%3cg%20id='Layer_1'%3e%3cg%3e%3cpath%20class='cls-1'%20d='M8.5,548.9c-6.8-6.8-9.4-14.5-3.4-25.6l39.3-69.1c6.8-11.1,20.5-11.1,29-5.1,23.9,16.2,67.4,46.9,121.2,46.9s58.9-21.3,58.9-51.2-31.6-58.9-87.9-86.2C82.8,318.4,0,272.3,0,169.9S65.7,0,197.2,0s157.1,45.2,182.7,64c10.2,6,8.5,21.3,5.1,27.3l-43.5,65.7c-6,9.4-20.5,16.2-37.6,6-19.6-13.7-70-46.1-115.2-46.1s-52.1,22.2-52.1,47,33.3,50.4,93,79.4c75.1,36.7,172.4,78.5,172.4,194.6s-76,176.7-201.5,176.7-172.3-46.1-192-65.7Z'/%3e%3cpath%20class='cls-1'%20d='M619.3,203.2c62.3,0,110.1,24.7,147.7,69.1,7.7,9.4,4.3,20.5-5.1,28.2l-55.5,53.8c-4.3,4.3-14.5,5.1-22.2-1.7-16.2-14.5-35.8-28.2-60.6-28.2-45.2,0-83.7,40.1-83.7,84.5s36.7,84.5,82,84.5,53.8-15.4,70.9-32.4c6.8-8.5,17.1-10.2,22.2-3.4l55.5,47.8c8.5,8.5,13.7,17.9,6.8,28.2-36.7,54.6-87.9,82-158.8,82-112.7,0-208.3-87.9-208.3-206.6-.1-116.2,96.4-205.8,209.1-205.8Z'/%3e%3cpath%20class='cls-1'%20d='M780.4,83.7c0-41,32.4-75.1,73.4-75.1s74.3,34.1,74.3,75.1-33.3,73.4-74.3,73.4-73.4-33.3-73.4-73.4ZM789.8,230.5c0-11.1,8.5-18.8,18.8-18.8h92.2c10.2,0,18.8,7.7,18.8,18.8v356.8c0,10.2-8.5,18.8-18.8,18.8h-92.2c-10.2,0-18.8-8.5-18.8-18.8V230.5Z'/%3e%3cpath%20class='cls-1'%20d='M937.5,227.1c0-10.2,6.8-18.8,21.3-18.8,40.1,0,63.2,24.8,69.1,57.2,21.3-29.9,57.2-62.3,122.1-62.3,122.9,0,164.7,87.1,164.7,195.5v188.7c0,10.2-8.5,18.8-17.9,18.8h-93c-11.1,0-18.8-8.5-18.8-18.8v-190.4c0-37.6-12.8-72.6-57.2-72.6s-59.8,27.3-59.8,67.4v195.5c0,8.5-4.3,18.8-17.9,18.8h-93.9c-10.2,0-18.8-8.5-18.8-18.8V227.1h.1Z'/%3e%3cpath%20class='cls-1'%20d='M1331.9,328.7c-9.4,0-17.1-8.5-17.1-18.8v-79.4c0-11.1,7.7-18.8,17.1-18.8h32.4v-109.3c0-10.2,8.5-18.8,18.8-18.8h93.9c9.4,0,17.1,8.5,17.1,18.8v109.3h79.4c10.2,0,18.8,7.7,18.8,18.8v79.4c0,10.2-8.5,18.8-18.8,18.8h-79.4v125.5c0,27.3,12.8,39.3,36.7,39.3s30.7-5.1,38.4-7.7c10.2-2.6,19.6,1.7,22.2,11.9l17.1,76c2.6,12-1.7,17.1-12.8,22.2-19.6,9.4-52.9,19.6-83.7,19.6-93.9,0-147.7-53.8-147.7-154.5v-132.3h-32.4Z'/%3e%3cpath%20class='cls-1'%20d='M1614,83.7c0-41,32.4-75.1,73.4-75.1s74.3,34.1,74.3,75.1-33.3,73.4-74.3,73.4-73.4-33.3-73.4-73.4ZM1623.4,230.5c0-11.1,8.5-18.8,18.8-18.8h92.2c10.2,0,18.8,7.7,18.8,18.8v356.8c0,10.2-8.5,18.8-18.8,18.8h-92.2c-10.2,0-18.8-8.5-18.8-18.8V230.5Z'/%3e%3cpath%20class='cls-1'%20d='M1774.5,27.3c0-9.4,8.5-18.8,18.8-18.8h92.2c10.2,0,18.8,9.4,18.8,18.8v560c0,10.2-8.5,18.8-18.8,18.8h-92.2c-10.2,0-18.8-8.5-18.8-18.8V27.3Z'/%3e%3cpath%20class='cls-1'%20d='M1923.3,27.3c0-9.4,8.5-18.8,18.8-18.8h92.2c10.2,0,18.8,9.4,18.8,18.8v560c0,10.2-8.5,18.8-18.8,18.8h-92.2c-10.2,0-18.8-8.5-18.8-18.8V27.3Z'/%3e%3cpath%20class='cls-1'%20d='M2211.2,354.3c44.4,0,77.7,17.1,77.7,17.1,0-38.4-25.6-60.6-71.7-60.6s-56.3,6-82,13.7c-15.4,5.1-22.2-6-23.9-20.5l-9.4-60.6c-2.6-17.1,6.8-24.8,15.4-27.3,9.4-3.4,61.5-12.8,114.4-12.8,109.3,0,181.8,61.5,181.8,171.6v216c0,10.2-6.8,18.8-21.3,18.8-38.4,0-60.6-21.3-68.3-50.4-22.2,29-59.8,56.3-121.2,56.3s-136.6-51.2-136.6-129.8c0-76,55.5-131.5,145.1-131.5ZM2236.8,519.9c23.9,0,44.4-19.6,44.4-43.5s-20.5-43.5-44.4-43.5-43.5,20.5-43.5,43.5,19.6,43.5,43.5,43.5Z'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e", ma = "_menuSize_1625e_1", fa = "_trigger_1625e_5", va = "_triggerText_1625e_9", _a = "_triggerSubMenu_1625e_13", Ca = "_triggerIcon_1625e_35", ya = "_userRole_1625e_47", Sa = "_menuItem_1625e_53", Ea = "_disableCursor_1625e_63", Ta = "_clickableMenuItem_1625e_67", ba = "_smallText_1625e_82", Aa = "_copyRightText_1625e_87", Ia = "_copyRightCaption_1625e_92", Na = "_firstName_1625e_96", wa = "_emailText_1625e_100", Oa = "_image_1625e_106", La = "_subMenuSection_1625e_111", Ma = "_subMenuOption_1625e_121", Pa = "_divider_1625e_137", Ra = "_selectedOption_1625e_141", Q = {
  menuSize: ma,
  trigger: fa,
  triggerText: va,
  triggerSubMenu: _a,
  triggerIcon: Ca,
  userRole: ya,
  menuItem: Sa,
  disableCursor: Ea,
  clickableMenuItem: Ta,
  smallText: ba,
  copyRightText: Aa,
  copyRightCaption: Ia,
  firstName: Na,
  emailText: wa,
  image: Oa,
  subMenuSection: La,
  subMenuOption: Ma,
  divider: Pa,
  selectedOption: Ra
}, Ua = ({ onCustomProfileMenuSelection: e, userInfo: t, profileMenuOptions: n, logOutCallBack: r, useWindowRedirection: o }) => {
  var s;
  const { _: i } = ye(), l = qt(null), [d, m] = j(!1), [g, C] = j(!1), [S, u] = j(i(h.SUPPLIER_VIEW)), v = Ze(), N = (p) => {
    const { key: _, label: U } = p;
    localStorage.getItem("selectedSubMenuKey") !== _ && (e == null || e(p), localStorage.setItem("selectedSubMenuKey", _), u(i(U)));
  };
  function A() {
    if (g) {
      C(!1);
      return;
    } else
      m(!1);
  }
  const k = (p) => p.subLinks && p.subLinks.length > 0, P = (p) => {
    Ue.trackEventInfo({
      type: "click",
      actionOn: "Profile Menu Item",
      location: h.locations.header
    });
    const { route: _, key: U, newTab: B, customEvent: ce, useWindowOpen: F } = p;
    if (k(p) && (m(!0), C(!g)), _ && U === "logOut")
      localStorage.removeItem("selectedSubMenuKey"), localStorage.removeItem("selectedMainMenuKey"), r == null || r(), setTimeout(() => V.logoutUser(_, B), 1500);
    else if (ce && e)
      e(Object.assign({}, p));
    else if (_)
      if (B) {
        const c = window.open(_, "_blank");
        c == null || c.focus();
      } else F || o ? window.open(_, "_self") : v(_);
  }, w = (p) => p ? `${p[0].toUpperCase()}${p.slice(1).toLowerCase()}` : "";
  ve(() => {
    const p = localStorage.getItem("selectedSubMenuKey") ? localStorage.getItem("selectedSubMenuKey") : h.SUPPLIER_VIEW_PAGE;
    u(p === h.SUPPLIER_VIEW_PAGE ? i(h.SUPPLIER_VIEW) : i(h.MERCHANT_VIEW));
  }, [
    n
  ]);
  const E = () => {
    V.redirectionOnUnauthorized("/login?lastUrl=/apps");
  };
  return t != null && t.authz ? a(Et, {
    isOpen: d || g,
    onClose: A,
    onOpen: () => m(!0),
    onClick: () => {
    },
    trigger: a(Yt, {
      ref: l,
      size: "medium",
      a11yLabel: "icon",
      UNSAFE_className: Q.trigger,
      "data-testid": "header-account-menu-button",
      children: a(Gt, {})
    }),
    triggerRef: l,
    position: "bottomRight",
    children: I("div", {
      className: Q.menuSize,
      children: [
        I(Le, {
          UNSAFE_className: Q.menuItem,
          "data-testid": "menu-option-user-details",
          disabled: !0,
          children: [
            a(Oe, {
              size: "medium",
              weight: 700,
              UNSAFE_className: Q.firstName,
              children: `${t == null ? void 0 : t.firstName} ${t == null ? void 0 : t.lastName}`
            }),
            a(xe, {
              UNSAFE_className: Q.userRole,
              as: "p",
              children: ((s = t == null ? void 0 : t.authz) === null || s === void 0 ? void 0 : s.group) && w(t.authz.group)
            }),
            a(xe, {
              as: "small",
              UNSAFE_className: Q.emailText,
              children: t == null ? void 0 : t.email
            })
          ]
        }),
        n.map((p) => I("div", {
          className: "",
          children: [
            p.divider && a(Ut, {}),
            p.subLinks && p.subLinks.length > 0 && a("div", {
              children: a("div", {
                className: Q.subMenuSection,
                children: g && p.subLinks.map((_) => I("div", {
                  children: [
                    _.divider && a(Ut, {}),
                    a(Le, {
                      "data-testid": `sub-menu-option-${_ == null ? void 0 : _.key}`,
                      id: `sub-menu-option-${_ == null ? void 0 : _.value}`,
                      onClick: () => {
                        N(_), C(!g);
                      },
                      className: [
                        Q.subMenuOption,
                        i(_.label) === S && Q.selectedOption,
                        Q.menuItem
                      ].join(" "),
                      children: a(Oe, {
                        as: "p",
                        size: "medium",
                        weight: 400,
                        children: i(_ == null ? void 0 : _.label)
                      })
                    }, _ == null ? void 0 : _.key)
                  ]
                }, _ == null ? void 0 : _.key))
              })
            }),
            a(Le, {
              "data-testid": `menu-option-${p == null ? void 0 : p.key}`,
              leadingIcon: p.icon,
              UNSAFE_className: Q.clickableMenuItem,
              onClick: () => P(p),
              children: k(p) ? a(Oe, {
                as: "p",
                size: "medium",
                weight: 400,
                children: S
              }) : p.caption ? a(xe, {
                as: "small",
                UNSAFE_className: Q.smallText,
                children: i(p.label)
              }) : a(Oe, {
                as: "p",
                size: "medium",
                weight: 400,
                children: i(p.label)
              })
            })
          ]
        }, p.key)),
        a(Le, {
          UNSAFE_className: Q.copyRightText,
          "data-testid": "copyright-caption",
          disabled: !0,
          children: I(xe, {
            as: "small",
            UNSAFE_className: Q.copyRightCaption,
            children: [
              "© ",
              (/* @__PURE__ */ new Date()).getFullYear(),
              " Walmart"
            ]
          })
        })
      ]
    })
  }) : a(ae, {
    onClick: E,
    variant: "tertiary",
    UNSAFE_className: Q.trigger,
    leading: a(Gt, {
      size: "small"
    }),
    children: a(Oe, {
      as: "span",
      size: "medium",
      weight: 700,
      UNSAFE_className: Q.triggerText,
      children: i(so)
    })
  });
}, Ga = "_banner_isedf_1", Da = "_action_isedf_14", xa = "_message_isedf_22", ka = "_linkAction_isedf_30", We = {
  banner: Ga,
  action: Da,
  message: xa,
  linkAction: ka
}, Ha = (e) => {
  const { message: t = "You are now acting on behalf of [User Name] from [Company Name]", actionLink: n, actionComponent: r, linkText: o, idName: s, onFeedback: i } = e, l = () => a(Ye, {
    a11yLabel: "icon",
    disabled: !1,
    size: "small",
    onClick: i,
    children: a(de.Close, {})
  }), d = () => a("div", {
    role: "link",
    id: `${s}Link`,
    onClick: n,
    className: We.linkAction,
    children: o
  }), m = () => r ? r() : n && o ? d() : l();
  return I("div", {
    className: We.banner,
    children: [
      a("div", {
        className: We.message,
        children: t
      }),
      a("div", {
        className: We.action,
        children: m()
      })
    ]
  });
}, Ba = "_trigger_1e7tl_1", Fa = "_triggerText_1e7tl_5", Va = "_menuButtonLeading_1e7tl_10", Wa = "_notEmpty_1e7tl_17", $a = "_menuItem_1e7tl_21", ja = "_productTag_1e7tl_34", za = "_externalAccessMargin_1e7tl_39", qa = "_logoPadding_1e7tl_43", Se = {
  trigger: Ba,
  triggerText: Fa,
  menuButtonLeading: Va,
  notEmpty: Wa,
  menuItem: $a,
  productTag: ja,
  externalAccessMargin: za,
  logoPadding: qa
}, Wt = ({ menuList: e, customTitleArea: t }) => {
  const { _: n } = ye(), r = y.useRef(null), [o, s] = y.useState(!1), i = (l, d = !1) => {
    Ue.trackEventInfo({
      type: "click",
      actionOn: "Header Drawer Menu Item",
      location: h.locations.menu
    }), d ? window.open(l, "_blank") : window.location.href = l;
  };
  return e.length ? a(Et, {
    isOpen: o,
    onClose: () => s(!1),
    onOpen: () => s(!0),
    trigger: I("div", {
      ref: r,
      className: `${Se.menuButtonLeading} ${Se.notEmpty}`,
      "data-testid": "header-product-menu-button",
      children: [
        a(Hr, {
          size: "small",
          color: $r
        }),
        a("img", {
          src: Ct,
          width: 63,
          height: 16,
          alt: h.SCINTILLA
        }),
        t || ""
      ]
    }),
    triggerRef: r,
    position: "bottomLeft",
    UNSAFE_className: "divMain",
    children: e ? a("div", {
      className: "divMenu",
      children: e.map((l) => a("div", {
        children: l.subApps && l.subApps.length > 0 ? l.subApps.map((d) => a(Le, {
          "data-testid": `account-submenu-option-${l == null ? void 0 : l.key}`,
          UNSAFE_className: Se.menuItem,
          onClick: () => i(d.redirectUrl),
          children: d.name
        }, d.code)) : I(Le, {
          "data-testid": `account-menu-option-${l == null ? void 0 : l.key}`,
          UNSAFE_className: Se.menuItem,
          onClick: () => i(l.redirectUrl, l.externalAccess),
          children: [
            n(l.label),
            l.flag ? a("label", {
              className: Se.productTag,
              children: l.flag
            }) : "",
            l.externalAccess ? a(Br, {
              size: "small",
              className: Se.externalAccessMargin
            }) : ""
          ]
        })
      }, l.key))
    }) : null
  }) : a("div", {
    className: Se.menuButtonLeading,
    children: I("div", {
      className: Se.logoPadding,
      children: [
        a("img", {
          src: Ct,
          height: 16,
          alt: h.SCINTILLA
        }),
        t || ""
      ]
    })
  });
}, Ya = "_trigger_humd2_1", Ka = "_triggerText_humd2_9", Za = "_userRole_humd2_21", Xa = "_menuItem_humd2_27", Ja = "_disableCursor_humd2_36", Qa = "_clickableMenuItem_humd2_40", ei = "_smallText_humd2_54", ti = "_copyRightText_humd2_59", ri = "_copyRightCaption_humd2_64", ni = "_firstName_humd2_68", oi = "_emailText_humd2_72", $t = {
  trigger: Ya,
  triggerText: Ka,
  userRole: Za,
  menuItem: Xa,
  disableCursor: Ja,
  clickableMenuItem: Qa,
  smallText: ei,
  copyRightText: ti,
  copyRightCaption: ri,
  firstName: ni,
  emailText: oi
}, si = ({ supportMenuOptions: e, useWindowRedirection: t }) => {
  const { _: n } = ye(), r = qt(null), [o, s] = j(!1), i = V.getCurrentApplicationHostInfo().currentDomain, l = Ze(), d = (m) => {
    const { route: g, externalPath: C } = m;
    if (g)
      if (C) {
        const S = window.open(g, "_blank");
        S == null || S.focus();
      } else t ? window.open(g, "_self") : l(g);
  };
  return a(Et, {
    isOpen: o,
    onClose: () => s(!1),
    onOpen: () => s(!0),
    trigger: a(Yt, {
      ref: r,
      a11yLabel: "icon",
      size: "medium",
      UNSAFE_className: $t.trigger,
      "data-testid": "header-support-menu-button",
      children: a(Fr, {})
    }),
    triggerRef: r,
    position: "bottomRight",
    children: a("div", {
      children: e.map((m) => {
        if (!m.allowedDomains || m.allowedDomains.includes(i))
          return a("div", {
            children: a(Le, {
              "data-testid": `support-menu-option-${m == null ? void 0 : m.key}`,
              UNSAFE_className: $t.clickableMenuItem,
              onClick: () => d(m),
              children: a(Oe, {
                as: "p",
                size: "medium",
                weight: 400,
                children: n(m.label)
              })
            })
          }, m.key);
      })
    })
  });
}, ai = "_container_1kg7a_1", ii = "_rightSection_1kg7a_12", li = "_rightSectionSkeleton_1kg7a_17", ci = "_logoSection_1kg7a_23", ui = "_titleText_1kg7a_28", di = "_triggerIcon_1kg7a_34", pi = "_leftSection_1kg7a_46", hi = "_companyNameText_1kg7a_50", gi = "_bannerText_1kg7a_55", mi = "_menuPadding_1kg7a_59", ne = {
  container: ai,
  rightSection: ii,
  rightSectionSkeleton: li,
  logoSection: ci,
  titleText: ui,
  triggerIcon: di,
  leftSection: pi,
  companyNameText: hi,
  bannerText: gi,
  menuPadding: mi
}, fi = (e) => {
  var t, n, r, { logoLabel: o = (t = h.LOGO_LABEL) === null || t === void 0 ? void 0 : t.message, title: s, titleProps: i, userInfoResponse: l, showLogo: d = !0, customTitleArea: m, logOutCallBack: g, showSupport: C = !0, redirectURL: S, hideBanner: u = !1, productDetailsResponse: v, preventRedirection: N = !1, useWindowRedirection: A = !1 } = e;
  const [k, P] = j([]), [w, E] = j([]), [p, _] = j(ir), { _: U } = ye(), [B, ce] = j(l), [F, c] = j(null), [f, T] = j(!1), [b, G] = j(!1), [R, x] = j(!1), [W, H] = j(!1), [L, $] = j({
    productInfo: v,
    error: {}
  }), [O, le] = j({
    userInfo: l,
    error: {},
    fetching: !0
  }), pe = Ze(), ue = window.location.pathname, te = V.getBannerDetails(B);
  ve(() => {
    !l || !v ? ee(void 0, void 0, void 0, function* () {
      le((Z) => Object.assign(Object.assign({}, Z), {
        fetching: !0
      }));
      try {
        const Z = yield Nt(), ge = yield wt(), Ge = V.mapContextToUserInfoObj(Z, ge.result);
        $({
          productInfo: ge.result,
          error: {}
        }), le({
          fetching: !1,
          error: {},
          userInfo: Ge
        });
      } catch (Z) {
        le(Object.assign(Object.assign({}, O), {
          fetching: !1,
          error: Z || {}
        })), $(Object.assign(Object.assign({}, L), {
          error: Z || {}
        })), console.log(Z);
      }
    }) : (le({
      fetching: !1,
      error: {},
      userInfo: l
    }), $({
      productInfo: L.productInfo,
      error: {}
    }));
  }, [
    l,
    v
  ]), ve(() => {
    O != null && O.userInfo && ce(O.userInfo);
  }, [
    O == null ? void 0 : O.userInfo
  ]), ve(() => {
    d && Array.isArray(B == null ? void 0 : B.products) && ee(void 0, void 0, void 0, function* () {
      const Z = L.productInfo && ho(B.products, L.productInfo) || {};
      P([
        ...B.companyType !== "BASIC_VENDOR" ? [
          {
            key: "HOME",
            label: h.HOME,
            accessStatus: "ACCESS_COMPLETE",
            redirectUrl: `${window.location.origin}/apps`
          }
        ] : [],
        ...Z
      ]);
    }), O != null && O.userInfo && (E(go(O.userInfo)), _(mo(O.userInfo)));
  }, [
    B,
    d,
    L.productInfo
  ]), ve(() => {
    var re, Z, ge, Ge, ot, st, at;
    const Mt = (O == null ? void 0 : O.userInfo) && V.checkForCompanySwitchUserWithTaggedCompany(O.userInfo), Sr = (O == null ? void 0 : O.userInfo) && V.checkForCompanySwitchUserWithUnknownCompany(O.userInfo), Er = ((re = O == null ? void 0 : O.userInfo) === null || re === void 0 ? void 0 : re.companyType) === h.UNKNOWN_COMPANY_VALUES || !1;
    if (!u && (O != null && O.userInfo) && V.checkForSuperAdmin(O.userInfo)) {
      T(!0);
      const it = localStorage.getItem(h.SELECTED_SUB_MENU), Be = !((ge = (Z = O.userInfo) === null || Z === void 0 ? void 0 : Z.authz) === null || ge === void 0) && ge.permissions ? V.getSuperAdminPersonaType(O.userInfo) : !1, lt = (it == null ? void 0 : it.toLowerCase()) || "", Pt = typeof Be == "string" && Be.toLowerCase() || !1, Tr = typeof Pt == "string" && (lt == null ? void 0 : lt.includes(Pt)) || !1;
      !((Ge = O.userInfo) === null || Ge === void 0) && Ge.companyName && Be === "Supplier" ? (c(`${(ot = O.userInfo) === null || ot === void 0 ? void 0 : ot.companyName}`), G(!1)) : Be === "Merchant" ? G(!0) : !N && Tr && !Object.values(h.allAccessRoutes).includes(ue) && (G(!1), he());
    } else !u && (O != null && O.userInfo) && V.check3pSponsoredSupplier(O.userInfo) ? (H(!0), c(`${(st = O.userInfo) === null || st === void 0 ? void 0 : st.companyName}`), !N && Er && !Object.values(h.allAccessRoutes).includes(ue) && he()) : !u && Mt ? (x(!!Mt), c(`${(at = O == null ? void 0 : O.userInfo) === null || at === void 0 ? void 0 : at.companyName}`)) : (T(!1), c(null), G(!1), H(!1), !N && Sr && !Object.values(h.allAccessRoutes).includes(ue) && he());
  }, [
    (n = O == null ? void 0 : O.userInfo) === null || n === void 0 ? void 0 : n.companyName,
    (r = O == null ? void 0 : O.userInfo) === null || r === void 0 ? void 0 : r.userType
  ]);
  function Ae() {
    Ue.trackEventInfo({
      type: "click",
      actionOn: "Profile Sub Menu Item",
      location: h.locations.header
    }), fe();
  }
  const fe = () => {
    $o().then((re) => {
      var Z;
      if (!((Z = re == null ? void 0 : re.result) === null || Z === void 0) && Z.persona) {
        const ge = re.result.persona.toLowerCase() === "merchant" ? h.MERCHANT_VIEW_PAGE : h.SUPPLIER_VIEW_PAGE;
        localStorage.setItem("selectedSubMenuKey", ge), ge === h.SUPPLIER_VIEW_PAGE ? Me(h.ROUTES.COMPANY_LIST) : ge === h.MERCHANT_VIEW_PAGE && window.open(h.ROUTES.APPS, "_self");
      }
    });
  }, he = () => {
    G(!1), localStorage.getItem("selectedSubMenuKey") === h.MERCHANT_VIEW_PAGE ? fe() : Me(h.ROUTES.COMPANY_LIST);
  }, Ie = () => {
    V.redirectionOnUnauthorized("/login?lastUrl=/apps");
  }, Me = (re) => {
    A ? window.open(re, "_self") : pe(re);
  };
  return I("div", {
    children: [
      (B == null ? void 0 : B.authz) && !u && (b || f || W || R) && a(Ha, {
        idName: te.bannerId,
        message: a("span", {
          children: !b || R ? I(X, {
            children: [
              a("span", {
                children: `${te.validBannerMessage} `
              }),
              a("span", {
                className: ne.companyNameText,
                children: F
              })
            ]
          }) : a("span", {
            className: ne.bannerText,
            children: U(h.MERCHANT_VIEW)
          })
        }),
        linkText: U(h.RETURN_TO_COMPANY_LIST),
        actionLink: () => he(),
        "data-testId": "header-banner"
      }),
      a("header", {
        className: ne.container,
        children: O != null && O.fetching ? I(X, {
          children: [
            a("div", {
              className: ne.leftSection,
              children: a(Re, {
                variant: "rectangle",
                height: 16,
                width: 64
              })
            }),
            I("div", {
              className: ne.rightSectionSkeleton,
              children: [
                a(Re, {
                  variant: "rectangle",
                  height: 24,
                  width: 24
                }),
                a(Re, {
                  variant: "rectangle",
                  height: 24,
                  width: 24
                })
              ]
            })
          ]
        }) : Object.values(h.ROUTES_WITH_MARKETING_HEADER).includes(ue) ? I(X, {
          children: [
            a("img", {
              src: Ct,
              className: ne.logoSection,
              height: 16,
              alt: h.SCINTILLA
            }),
            a("div", {
              className: ne.rightSection,
              children: B != null && B.authz ? a(ae, {
                variant: "primary",
                size: "small",
                id: "loginBtn",
                onClick: () => Me(h.ROUTES.APPS),
                "data-testId": "login-button",
                children: U(h.VIEW_APPS)
              }) : a(ae, {
                variant: "primary",
                size: "small",
                id: "loginBtn",
                onClick: Ie,
                "data-testid": "login-button",
                children: U(h.LOGIN_LABEL)
              })
            })
          ]
        }) : B != null && B.authz ? I(X, {
          children: [
            d ? a("div", {
              className: ne.menuPadding,
              children: a(Wt, {
                title: s,
                titleProps: i,
                ariaLabel: U(o),
                menuList: k,
                customTitleArea: m
              })
            }) : I("div", {
              className: ne.logoSection,
              children: [
                a(Vr, {
                  size: "large",
                  className: ne.triggerIcon,
                  onClick: () => {
                    S != null && S.length ? Me(S) : pe(-1);
                  },
                  "data-testId": "back-navigation-icon"
                }),
                a(Oe, {
                  as: "p",
                  size: "large",
                  weight: 700,
                  UNSAFE_className: ne.titleText,
                  children: s
                })
              ]
            }),
            I("div", {
              className: ne.rightSection,
              children: [
                C && a(si, {
                  supportMenuOptions: p,
                  useWindowRedirection: A
                }),
                (O == null ? void 0 : O.userInfo) && a(Ua, {
                  userInfo: O.userInfo,
                  profileMenuOptions: w,
                  onCustomProfileMenuSelection: Ae,
                  logOutCallBack: g,
                  useWindowRedirection: A
                })
              ]
            })
          ]
        }) : I(X, {
          children: [
            a("div", {
              className: ne.menuPadding,
              children: a(Wt, {
                title: s,
                titleProps: i,
                ariaLabel: U(o),
                menuList: k,
                customTitleArea: m
              })
            }),
            a("div", {
              className: ne.rightSection,
              children: a(ae, {
                variant: "primary",
                size: "small",
                id: "loginBtn",
                onClick: Ie,
                children: U(h.LOGIN_LABEL)
              })
            })
          ]
        })
      })
    ]
  });
}, vi = He(fi), _i = JSON.parse('{"VN/Ohz":"Ok, got it!","Ey6lWd":"There seems to be a problem, please retry after sometime."}'), Ci = JSON.parse('{"VN/Ohz":"¡Muy bien, listo!","Ey6lWd":"Parece que hubo un problema. Vuelve a intentarlo más tarde."}'), yi = JSON.parse(`{"VN/Ohz":"D'accord, j'ai compris !","Ey6lWd":"Il semble y avoir un problème, veuillez réessayer après un certain temps."}`);
Ce.load({
  "en-US": _i,
  "es-MX": Ci,
  "fr-CA": yi
});
const ht = {
  announcementsButtonText: {
    id: "VN/Ohz"
  },
  defaultErrorMessage: {
    id: "Ey6lWd"
  }
}, Si = () => oe.httpRequest(`${V.getAPIURL({
  key: h.URL_KEY.PENDING_ANNOUNCEMENTS
})}`), Ei = (e, t) => {
  const n = `${V.getAPIURL({
    key: h.URL_KEY.ANNOUNCEMENT_DETAILS
  })}/${e}`;
  return oe.httpRequest(t ? `${n}?urlPath=${t}` : n);
}, Ti = (e) => {
  const t = Object.assign(Object.assign({}, h.httpMethods.HTTP_REQ_DEFAULT_HEADERS), {
    "Content-Type": "application/json;charset=UTF-8"
  });
  return oe.httpRequest(`${V.getAPIURL({
    key: h.URL_KEY.ACKNOWLEDGE_ANNOUNCEMENTS
  })}`, e, h.httpMethods.HTTP_METHODS.PUT, t);
}, bi = "_button_1iijy_1", Ai = "_modalContent_1iijy_7", jt = {
  button: bi,
  modalContent: Ai
}, Ii = ({ locationBased: e, routeChange: t }) => {
  const [n, r] = j([]), [o, s] = j(!1), [i, l] = j(""), { addSnack: d } = Lr(), { _: m } = ye(), { getLanguage: g } = gr();
  ve(() => {
    ee(void 0, void 0, void 0, function* () {
      const v = yield g();
      l(v || h.DEFAULT_LOCALE);
    });
  }, [
    g
  ]);
  const C = Rr(() => ee(void 0, void 0, void 0, function* () {
    var u;
    const v = e ? `${window.location.pathname}${window.location.search}` : "";
    let N = {
      result: {
        announcements: []
      },
      requestId: ""
    };
    try {
      N = yield Si();
      const A = (u = N == null ? void 0 : N.result) === null || u === void 0 ? void 0 : u.announcements;
      if (Array.isArray(A) && A.length > 0) {
        const k = A.toSorted((E, p) => new Date(p.startDate).getTime() - new Date(E.startDate).getTime()), P = [];
        for (const E of k)
          try {
            const p = yield Ei(E.id, v);
            if (p != null && p.result) {
              const _ = Object.assign(E, p.result, {
                isOpen: !0
              });
              P.push(_);
            }
          } catch {
            return null;
          }
        const w = P.filter(Boolean);
        Array.isArray(w) && w.length > 0 && (r(w), s(!0));
      }
    } catch (A) {
      A && d({
        message: m(ht.defaultErrorMessage)
      });
    }
  }), [
    e,
    d
  ]);
  ve(() => {
    C();
  }, [
    C,
    t
  ]);
  const S = (u) => ee(void 0, void 0, void 0, function* () {
    var v, N, A;
    if (u) {
      const k = {
        announcementIds: [
          u.id
        ],
        countryCd: Array.isArray(u == null ? void 0 : u.countries) && (u == null ? void 0 : u.countries.length) > 0 ? ((A = (N = (v = V.getCurrentApplicationHostInfo().currentDomain) === null || v === void 0 ? void 0 : v.split) === null || N === void 0 ? void 0 : N.call(v, "-")) === null || A === void 0 ? void 0 : A[1]) || (u == null ? void 0 : u.countries[0]) : h.countryCodes.us,
        storeNbr: Array.isArray(u == null ? void 0 : u.stores) && (u == null ? void 0 : u.stores.length) > 0 ? u == null ? void 0 : u.stores[0] : 0,
        version: Array.isArray(u == null ? void 0 : u.versions) && (u == null ? void 0 : u.versions.length) > 0 ? u == null ? void 0 : u.versions[0] : "",
        languageCode: Array.isArray(u == null ? void 0 : u.languages) && (u == null ? void 0 : u.languages.length) > 0 ? u == null ? void 0 : u.languages[0] : h.languageCodes.en,
        data: ""
      };
      try {
        yield Ti(k);
        const { id: P } = u, w = n.filter((E) => (E == null ? void 0 : E.id) !== P);
        r(w);
      } catch (P) {
        P && d({
          message: m(ht.defaultErrorMessage)
        });
      }
    }
  });
  return a(X, {
    children: o ? Array.isArray(n) && n.map((u) => {
      var v, N;
      const A = (N = (v = u == null ? void 0 : u.translations) === null || v === void 0 ? void 0 : v.filter((k) => (k == null ? void 0 : k.languageCode.toLowerCase()) === (i == null ? void 0 : i.split("-")[0].toLowerCase()))[0]) === null || N === void 0 ? void 0 : N.content;
      return A ? a(zt, {
        size: "medium",
        actions: a(ae, {
          variant: "primary",
          size: "medium",
          UNSAFE_className: jt.button,
          onClick: () => S(u),
          isFullWidth: !0,
          children: m(ht.announcementsButtonText)
        }),
        closeButtonProps: {
          "aria-label": "Close Modal"
        },
        isOpen: u == null ? void 0 : u.isOpen,
        onClose: () => S(u),
        title: u == null ? void 0 : u.name,
        UNSAFE_style: {
          zIndex: 1500
        },
        children: A && a("div", {
          className: jt.modalContent,
          dangerouslySetInnerHTML: {
            __html: A
          }
        })
      }, u == null ? void 0 : u.id) : null;
    }) : null
  });
}, _l = He(Ii), Ni = "_globalNavSideBar_1k58r_1", wi = "_navLogoContainer_1k58r_15", Oi = "_navMainIcon_1k58r_23", Li = "_navLogo_1k58r_15", Mi = "_navItem_1k58r_39", Pi = "_selected_1k58r_59", Ri = "_skeletonSection_1k58r_72", $e = {
  globalNavSideBar: Ni,
  navLogoContainer: wi,
  navMainIcon: Oi,
  navLogo: Li,
  navItem: Mi,
  selected: Pi,
  skeletonSection: Ri
}, Ui = JSON.parse('{"8TlWlx":"Customer Perception","yyRDbJ":"Digital Landscapes","At7+BQ":"Examine sales and inventory performance to help you improve strategy and planning","i0qMbr":"Home","nucq6s":"Identify media activation opportunities informed by real-time shopper insights","S/5Hl0":"Include the customer voice in your decision-making process by connecting with real Walmart shoppers","jgRxbS":"Inform your digital strategy with online shopper data from Walmart.com and the Walmart mobile app","3hJypY":"Insights","EnWBzP":"Insights Activation","JVgJuA":"Insights and Analysis into modular implementation and state of shelf across stores to improve modular compliance, reduce lost basket opportunities and customer friction.","OByGCy":"Modular Intelligence","KHyT9h":"Powered by Walmart Connect","qb1l+/":"Report Builder","2gwsnC":"Shopper Behavior","sS11Pa":"Shopper Behavior content","02w3OH":"Unlock answers to key questions quickly with a full-business view of data that can be personalized to suit your needs"}'), Gi = JSON.parse('{"8TlWlx":"Customer Perception","yyRDbJ":"Paisajes digitales","At7+BQ":"Examine sales and inventory performance to help you improve strategy and planning","i0qMbr":"Inicio","nucq6s":"Identify media activation opportunities informed by real-time shopper insights","S/5Hl0":"Include the customer voice in your decision-making process by connecting with real Walmart shoppers","jgRxbS":"Inform your digital strategy with online shopper data from Walmart.com and the Walmart mobile app","3hJypY":"Insights","EnWBzP":"Activación de insights","JVgJuA":"Insights and Analysis into modular implementation and state of shelf across stores to improve modular compliance, reduce lost basket opportunities and customer friction.","OByGCy":"Modular Intelligence","KHyT9h":"Con la tecnología de Walmart Connect","qb1l+/":"Generador de Reportes","2gwsnC":"Shopper Behavior","sS11Pa":"Shopper Behavior content","02w3OH":"Unlock answers to key questions quickly with a full-business view of data that can be personalized to suit your needs"}'), Di = JSON.parse(`{"8TlWlx":"Perception du client","yyRDbJ":"Paysages numériques","At7+BQ":"Examine sales and inventory performance to help you improve strategy and planning","i0qMbr":"Articles pour la maison","nucq6s":"Identify media activation opportunities informed by real-time shopper insights","S/5Hl0":"Include the customer voice in your decision-making process by connecting with real Walmart shoppers","jgRxbS":"Inform your digital strategy with online shopper data from Walmart.com and the Walmart mobile app","3hJypY":"Perspectives","EnWBzP":"Activation des perspectives","JVgJuA":"Insights and Analysis into modular implementation and state of shelf across stores to improve modular compliance, reduce lost basket opportunities and customer friction.","OByGCy":"Modular Intelligence","KHyT9h":"Propulsé par Walmart Connect","qb1l+/":"Générateur de rapports","2gwsnC":"Comportement de l'acheteur","sS11Pa":"Shopper Behavior content","02w3OH":"Unlock answers to key questions quickly with a full-business view of data that can be personalized to suit your needs"}`), rt = () => /* @__PURE__ */ a("svg", {
  fill: "currentColor",
  height: "1em",
  viewBox: "0 0 16 16",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  style: {
    fontSize: "1rem",
    verticalAlign: "-0.175em"
  },
  children: /* @__PURE__ */ a("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd",
    children: /* @__PURE__ */ a("path", {
      d: "M2.57808 14C2.4206 14 2.28725 13.9457 2.178 13.8371C2.06862 13.7286 2.01393 13.5941 2.01393 13.4337V12.4803C2.01393 12.3199 2.06718 12.1854 2.1737 12.0769C2.28021 11.9683 2.41214 11.914 2.56947 11.914C2.72694 11.914 2.8603 11.9683 2.96954 12.0769C3.07893 12.1854 3.13362 12.3199 3.13362 12.4803V13.4337C3.13362 13.5941 3.08037 13.7286 2.97385 13.8371C2.86734 13.9457 2.73541 14 2.57808 14ZM5.29119 14C5.13372 14 5.00036 13.9457 4.89112 13.8371C4.78173 13.7286 4.72704 13.5941 4.72704 13.4337V9.34051C4.72704 9.18659 4.7803 9.0543 4.88681 8.94365C4.99333 8.83286 5.12525 8.77746 5.28258 8.77746C5.44006 8.77746 5.57341 8.83177 5.68266 8.94038C5.79204 9.04886 5.84674 9.18332 5.84674 9.34378V13.4369C5.84674 13.5909 5.79348 13.7232 5.68696 13.8338C5.58045 13.9446 5.44853 14 5.29119 14ZM8.00431 14C7.84683 14 7.71347 13.9457 7.60423 13.8371C7.49484 13.7286 7.44015 13.5941 7.44015 13.4337V11.4348C7.44015 11.2743 7.49341 11.1399 7.59992 11.0314C7.70644 10.9228 7.83836 10.8685 7.99569 10.8685C8.15317 10.8685 8.28653 10.9228 8.39577 11.0314C8.50516 11.1399 8.55985 11.2743 8.55985 11.4348V13.4337C8.55985 13.5941 8.50659 13.7286 8.40008 13.8371C8.29356 13.9457 8.16164 14 8.00431 14ZM10.7174 14C10.5599 14 10.4266 13.9457 10.3173 13.8371C10.208 13.7286 10.1533 13.5941 10.1533 13.4337V9.86653C10.1533 9.70608 10.2065 9.57161 10.313 9.46314C10.4196 9.35452 10.5515 9.30021 10.7088 9.30021C10.8663 9.30021 10.9996 9.35452 11.1089 9.46314C11.2183 9.57161 11.273 9.70608 11.273 9.86653V13.4337C11.273 13.5941 11.2197 13.7286 11.1132 13.8371C11.0067 13.9457 10.8748 14 10.7174 14ZM13.4305 14C13.2731 14 13.1397 13.9457 13.0305 13.8371C12.9211 13.7286 12.8664 13.5941 12.8664 13.4337V7.77551C12.8664 7.61506 12.9196 7.48059 13.0261 7.37212C13.1327 7.2635 13.2646 7.20919 13.4219 7.20919C13.5794 7.20919 13.7128 7.2635 13.822 7.37212C13.9314 7.48059 13.9861 7.61506 13.9861 7.77551V13.4337C13.9861 13.5941 13.9328 13.7286 13.8263 13.8371C13.7198 13.9457 13.5879 14 13.4305 14ZM9.03228 8.23292C8.85973 8.23292 8.68991 8.20098 8.52281 8.13708C8.35572 8.07319 8.20133 7.96944 8.05965 7.82583L6.12343 5.86702C6.07376 5.81678 6.01024 5.79166 5.93287 5.79166C5.85549 5.79166 5.79197 5.81678 5.7423 5.86702L2.98462 8.65679C2.87078 8.7718 2.7352 8.83213 2.57787 8.83779C2.42053 8.84331 2.28158 8.78581 2.16099 8.66528C2.04859 8.55013 1.99505 8.4177 2.00036 8.26799C2.00567 8.11813 2.06704 7.9836 2.18446 7.86438L4.95894 5.05784C5.09618 4.91626 5.2477 4.81302 5.4135 4.74811C5.5793 4.6832 5.75063 4.65074 5.92748 4.65074C6.10448 4.65074 6.27617 4.68305 6.44254 4.74767C6.60892 4.81229 6.76367 4.91568 6.90679 5.05784L8.843 7.01665C8.89267 7.06689 8.95619 7.09201 9.03357 7.09201C9.11094 7.09201 9.17446 7.06689 9.22413 7.01665L13.0154 3.18137C13.1292 3.06636 13.2648 3.00603 13.4221 3.00036C13.5795 2.99484 13.7184 3.05235 13.839 3.17287C13.9514 3.28802 14.005 3.42045 13.9996 3.57016C13.9943 3.72002 13.933 3.85456 13.8155 3.97378L10.0075 7.82583C9.86437 7.96944 9.70919 8.07319 9.54195 8.13708C9.37457 8.20098 9.20468 8.23292 9.03228 8.23292Z",
      fill: "#2E2F32"
    })
  })
}), nt = () => /* @__PURE__ */ a("svg", {
  fill: "currentColor",
  height: "1em",
  viewBox: "0 0 16 16",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  style: {
    fontSize: "1rem",
    verticalAlign: "-0.175em"
  },
  children: /* @__PURE__ */ a("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd",
    children: /* @__PURE__ */ a("path", {
      id: "Vector",
      d: "M3.77946 10.8923L6.26146 8.41033C6.36068 8.31111 6.47779 8.26217 6.61279 8.2635C6.74779 8.26472 6.8649 8.31706 6.96413 8.4205C7.05635 8.52117 7.10246 8.63867 7.10246 8.773C7.10246 8.90722 7.05635 9.02389 6.96413 9.123L4.21796 11.8795C4.0974 11.9999 3.95679 12.0602 3.79613 12.0602C3.63546 12.0602 3.49485 11.9999 3.37429 11.8795L2.01146 10.5167C1.91924 10.4243 1.87418 10.3083 1.87629 10.1685C1.8784 10.0288 1.92562 9.91283 2.01796 9.8205C2.11029 9.72817 2.22668 9.682 2.36712 9.682C2.50757 9.682 2.62324 9.72817 2.71413 9.8205L3.77946 10.8923ZM3.77946 5.81533L6.26146 3.33333C6.36068 3.23422 6.47779 3.18528 6.61279 3.1865C6.74779 3.18783 6.8649 3.24022 6.96413 3.34367C7.05635 3.44433 7.10246 3.56178 7.10246 3.696C7.10246 3.83033 7.05635 3.94706 6.96413 4.04617L4.21796 6.8025C4.0974 6.92306 3.95679 6.98333 3.79613 6.98333C3.63546 6.98333 3.49485 6.92306 3.37429 6.8025L2.01146 5.43967C1.91924 5.34744 1.87418 5.23144 1.87629 5.09167C1.8784 4.95189 1.92562 4.83589 2.01796 4.74367C2.11029 4.65133 2.22668 4.60517 2.36712 4.60517C2.50757 4.60517 2.62324 4.65133 2.71413 4.74367L3.77946 5.81533ZM9.17296 11.0385C9.03129 11.0385 8.91257 10.9906 8.81679 10.8947C8.7209 10.7988 8.67296 10.6799 8.67296 10.5382C8.67296 10.3965 8.7209 10.2778 8.81679 10.182C8.91257 10.0863 9.03129 10.0385 9.17296 10.0385H13.8396C13.9813 10.0385 14.1001 10.0864 14.196 10.1823C14.2917 10.2782 14.3396 10.397 14.3396 10.5387C14.3396 10.6804 14.2917 10.7992 14.196 10.8948C14.1001 10.9906 13.9813 11.0385 13.8396 11.0385H9.17296ZM9.17296 5.9615C9.03129 5.9615 8.91257 5.91356 8.81679 5.81767C8.7209 5.72178 8.67296 5.603 8.67296 5.46133C8.67296 5.31956 8.7209 5.20083 8.81679 5.10517C8.91257 5.00939 9.03129 4.9615 9.17296 4.9615H13.8396C13.9813 4.9615 14.1001 5.00944 14.196 5.10533C14.2917 5.20122 14.3396 5.32006 14.3396 5.46183C14.3396 5.6035 14.2917 5.72222 14.196 5.818C14.1001 5.91367 13.9813 5.9615 13.8396 5.9615H9.17296Z"
    })
  })
}), qe = () => /* @__PURE__ */ a("svg", {
  fill: "currentColor",
  height: "1em",
  viewBox: "0 0 16 16",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  style: {
    fontSize: "1rem",
    verticalAlign: "-0.175em"
  },
  children: /* @__PURE__ */ a("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd",
    children: /* @__PURE__ */ a("path", {
      id: "Vector",
      d: "M2.53843 7.46903H3.61529C3.76809 7.46903 3.89599 7.52322 3.99901 7.63159C4.10215 7.73984 4.15372 7.87424 4.15372 8.03479C4.15372 8.19534 4.10215 8.32975 3.99901 8.43799C3.89599 8.54637 3.76809 8.60056 3.61529 8.60056H2.53843C2.38564 8.60056 2.25773 8.54637 2.15471 8.43799C2.05157 8.32975 2 8.19534 2 8.03479C2 7.87424 2.05157 7.73984 2.15471 7.63159C2.25773 7.52322 2.38564 7.46903 2.53843 7.46903ZM3.93835 11.6151L4.68946 10.8259C4.79619 10.7137 4.9211 10.6584 5.06421 10.6597C5.20731 10.6613 5.33456 10.7166 5.44596 10.8259C5.55735 10.9429 5.6149 11.0773 5.61861 11.2291C5.6222 11.381 5.56836 11.5154 5.45708 11.6325L4.70597 12.4217C4.59924 12.5339 4.47247 12.5892 4.32566 12.5877C4.17885 12.5863 4.04975 12.5271 3.93835 12.41C3.83437 12.293 3.78053 12.1605 3.77682 12.0125C3.77311 11.8645 3.82695 11.732 3.93835 11.6151ZM4.68946 5.2437L3.93835 4.45446C3.83162 4.34232 3.77891 4.21106 3.78023 4.06069C3.78167 3.91033 3.83437 3.77662 3.93835 3.65957C4.04975 3.54252 4.17765 3.48205 4.32207 3.47815C4.46661 3.47438 4.59458 3.53095 4.70597 3.64788L5.45708 4.43711C5.56381 4.54926 5.61646 4.68247 5.61502 4.83673C5.61371 4.99099 5.55735 5.12665 5.44596 5.2437C5.33456 5.35296 5.20845 5.40953 5.06762 5.41343C4.92679 5.41733 4.80074 5.36075 4.68946 5.2437ZM12.6871 13.8099L9.81406 10.791L9.35155 12.2707C9.32762 12.349 9.28622 12.409 9.22735 12.4506C9.16848 12.4922 9.10543 12.513 9.03818 12.513C8.97106 12.513 8.9092 12.4902 8.8526 12.4447C8.79601 12.3993 8.75575 12.3375 8.73182 12.2592L7.42289 7.70703C7.39896 7.61123 7.39968 7.52027 7.42505 7.43414C7.45041 7.34815 7.49301 7.27372 7.55283 7.21086C7.61266 7.14799 7.68349 7.10324 7.76533 7.07658C7.8473 7.05005 7.9338 7.04936 8.02486 7.07451L12.4206 8.45685C12.4951 8.482 12.5522 8.52437 12.5918 8.58396C12.6314 8.64343 12.6512 8.70843 12.6512 8.77896C12.6512 8.84962 12.6344 8.91468 12.6008 8.97415C12.5672 9.03362 12.5131 9.07592 12.4386 9.10107L11.0097 9.6393L13.8054 12.5769C13.9352 12.7132 14 12.8722 14 13.054C14 13.2358 13.9352 13.3949 13.8054 13.5314L13.5404 13.8099C13.4198 13.9366 13.2775 14 13.1137 14C12.9499 14 12.8077 13.9366 12.6871 13.8099ZM7.78472 3.69729V2.56576C7.78472 2.40521 7.83623 2.27081 7.93925 2.16256C8.04239 2.05419 8.17035 2 8.32315 2C8.47594 2 8.60385 2.05419 8.70687 2.16256C8.81001 2.27081 8.86158 2.40521 8.86158 2.56576V3.69729C8.86158 3.85784 8.81001 3.99224 8.70687 4.10049C8.60385 4.20886 8.47594 4.26305 8.32315 4.26305C8.17035 4.26305 8.04239 4.20886 7.93925 4.10049C7.83623 3.99224 7.78472 3.85784 7.78472 3.69729ZM11.1892 4.43711L11.9513 3.63637C12.0507 3.5319 12.1738 3.47651 12.3206 3.47023C12.4674 3.46394 12.5965 3.51932 12.7078 3.63637C12.8119 3.74563 12.8657 3.87619 12.8693 4.02807C12.873 4.17982 12.8229 4.31422 12.7189 4.43127L11.9568 5.2437C11.8574 5.35585 11.7343 5.41123 11.5875 5.40985C11.4407 5.40834 11.3116 5.35296 11.2002 5.2437C11.0889 5.12665 11.0314 4.99225 11.0277 4.8405C11.024 4.68863 11.0778 4.55416 11.1892 4.43711Z"
    })
  })
}), Ot = () => /* @__PURE__ */ a("svg", {
  fill: "currentColor",
  height: "1em",
  viewBox: "0 0 16 16",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  style: {
    fontSize: "1rem",
    verticalAlign: "-0.175em"
  },
  children: /* @__PURE__ */ a("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd",
    children: /* @__PURE__ */ a("path", {
      d: "M2.5 12.3303V3.66972C2.5 3.34802 2.61453 3.07265 2.84359 2.84359C3.07265 2.61453 3.34802 2.5 3.66972 2.5H12.3303C12.652 2.5 12.9274 2.61453 13.1564 2.84359C13.3855 3.07265 13.5 3.34802 13.5 3.66972V12.3303C13.5 12.652 13.3855 12.9274 13.1564 13.1564C12.9274 13.3855 12.652 13.5 12.3303 13.5H3.66972C3.34802 13.5 3.07265 13.3855 2.84359 13.1564C2.61453 12.9274 2.5 12.652 2.5 12.3303ZM3.47059 6.10865H12.5294V3.66972C12.5294 3.61159 12.5108 3.56387 12.4734 3.52656C12.4361 3.48925 12.3884 3.47059 12.3303 3.47059H3.66972C3.61159 3.47059 3.56387 3.48925 3.52656 3.52656C3.48925 3.56387 3.47059 3.61159 3.47059 3.66972V6.10865ZM6.81038 9.31903H9.18962V7.07924H6.81038V9.31903ZM6.81038 12.5294H9.18962V10.2896H6.81038V12.5294ZM3.47059 9.31903H5.83979V7.07924H3.47059V9.31903ZM10.1602 9.31903H12.5294V7.07924H10.1602V9.31903ZM3.66972 12.5294H5.83979V10.2896H3.47059V12.3303C3.47059 12.3884 3.48925 12.4361 3.52656 12.4734C3.56387 12.5108 3.61159 12.5294 3.66972 12.5294ZM10.1602 12.5294H12.3303C12.3884 12.5294 12.4361 12.5108 12.4734 12.4734C12.5108 12.4361 12.5294 12.3884 12.5294 12.3303V10.2896H10.1602V12.5294Z"
    })
  })
}), Cr = () => /* @__PURE__ */ a("svg", {
  fill: "currentColor",
  height: "1em",
  viewBox: "0 0 16 16",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  style: {
    fontSize: "1rem",
    verticalAlign: "-0.175em"
  },
  children: /* @__PURE__ */ a("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd",
    children: /* @__PURE__ */ a("path", {
      id: "Vector",
      d: "M8.00113 14.3333C7.12513 14.3333 6.30174 14.1671 5.53096 13.8347C4.76018 13.5022 4.08974 13.0511 3.51963 12.4812C2.94951 11.9113 2.49813 11.2411 2.16546 10.4707C1.8329 9.70022 1.66663 8.87705 1.66663 8.00116C1.66663 7.12516 1.83285 6.30178 2.16529 5.531C2.49774 4.76022 2.9489 4.08978 3.51879 3.51966C4.08868 2.94955 4.75885 2.49816 5.52929 2.1655C6.29974 1.83294 7.1229 1.66666 7.99879 1.66666C8.87479 1.66666 9.69818 1.83289 10.469 2.16533C11.2397 2.49778 11.9102 2.94894 12.4803 3.51883C13.0504 4.08872 13.5018 4.75889 13.8345 5.52933C14.167 6.29978 14.3333 7.12294 14.3333 7.99883C14.3333 8.87483 14.1671 9.69822 13.8346 10.469C13.5022 11.2398 13.051 11.9102 12.4811 12.4803C11.9112 13.0504 11.2411 13.5018 10.4706 13.8345C9.70018 14.1671 8.87702 14.3333 8.00113 14.3333ZM7.99996 13.3333C9.48885 13.3333 10.75 12.8167 11.7833 11.7833C12.8166 10.75 13.3333 9.48889 13.3333 8C13.3333 6.51111 12.8166 5.25 11.7833 4.21666C10.75 3.18333 9.48885 2.66666 7.99996 2.66666C6.51107 2.66666 5.24996 3.18333 4.21663 4.21666C3.18329 5.25 2.66663 6.51111 2.66663 8C2.66663 9.48889 3.18329 10.75 4.21663 11.7833C5.24996 12.8167 6.51107 13.3333 7.99996 13.3333ZM8.00146 11.6667C6.98335 11.6667 6.11746 11.3103 5.40379 10.5977C4.69013 9.885 4.33329 9.01961 4.33329 8.0015C4.33329 6.98339 4.68963 6.1175 5.40229 5.40383C6.11496 4.69016 6.98035 4.33333 7.99846 4.33333C9.01657 4.33333 9.88246 4.68966 10.5961 5.40233C11.3098 6.115 11.6666 6.98039 11.6666 7.9985C11.6666 9.01661 11.3103 9.8825 10.5976 10.5962C9.88496 11.3098 9.01957 11.6667 8.00146 11.6667ZM7.99996 10.6667C8.73329 10.6667 9.36107 10.4056 9.88329 9.88333C10.4055 9.36111 10.6666 8.73333 10.6666 8C10.6666 7.26666 10.4055 6.63889 9.88329 6.11666C9.36107 5.59444 8.73329 5.33333 7.99996 5.33333C7.26663 5.33333 6.63885 5.59444 6.11663 6.11666C5.5944 6.63889 5.33329 7.26666 5.33329 8C5.33329 8.73333 5.5944 9.36111 6.11663 9.88333C6.63885 10.4056 7.26663 10.6667 7.99996 10.6667ZM7.99996 9C7.72729 9 7.49246 8.9015 7.29546 8.7045C7.09846 8.5075 6.99996 8.27266 6.99996 8C6.99996 7.72733 7.09846 7.4925 7.29546 7.2955C7.49246 7.0985 7.72729 7 7.99996 7C8.27263 7 8.50746 7.0985 8.70446 7.2955C8.90146 7.4925 8.99996 7.72733 8.99996 8C8.99996 8.27266 8.90146 8.5075 8.70446 8.7045C8.50746 8.9015 8.27263 9 7.99996 9Z"
    })
  })
}), Lt = () => /* @__PURE__ */ a("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  children: /* @__PURE__ */ a("path", {
    d: "M1.20513 11.3333C0.868378 11.3333 0.583333 11.2166 0.35 10.9833C0.116667 10.75 0 10.4649 0 10.1282L0 1.20513C0 0.868379 0.116667 0.583333 0.35 0.35C0.583333 0.116667 0.868378 0 1.20513 0L4.91023 0C5.05211 0 5.17091 0.0478671 5.26663 0.1436C5.36236 0.239323 5.41022 0.358122 5.41022 0.5C5.41022 0.641878 5.36236 0.760678 5.26663 0.856401C5.17091 0.952123 5.05211 0.999984 4.91023 0.999984L1.20513 0.999984C1.15384 0.999984 1.10683 1.02135 1.06408 1.06408C1.02135 1.10683 0.999983 1.15385 0.999983 1.20513L0.999983 10.1282C0.999983 10.1795 1.02135 10.2265 1.06408 10.2692C1.10683 10.312 1.15384 10.3333 1.20513 10.3333L10.1282 10.3333C10.1795 10.3333 10.2265 10.312 10.2692 10.2692C10.3119 10.2265 10.3333 10.1795 10.3333 10.1282L10.3333 6.42307C10.3333 6.28119 10.3812 6.16239 10.4769 6.06667C10.5726 5.97095 10.6914 5.92308 10.8333 5.92308C10.9752 5.92308 11.094 5.97095 11.1897 6.06667C11.2854 6.16239 11.3333 6.28119 11.3333 6.42307L11.3333 10.1282C11.3333 10.4649 11.2166 10.75 10.9833 10.9833C10.75 11.2166 10.4649 11.3333 10.1282 11.3333L1.20513 11.3333ZM10.3333 1.70253L4.49742 7.53843C4.40511 7.63075 4.28908 7.67797 4.14935 7.6801C4.00961 7.68223 3.89144 7.63501 3.79487 7.53843C3.69829 7.44186 3.65 7.32477 3.65 7.18717C3.65 7.04956 3.69829 6.93246 3.79487 6.83588L9.63077 0.999984L7.49997 0.999984C7.35809 0.999984 7.23929 0.952123 7.14357 0.856401C7.04784 0.760678 6.99998 0.641878 6.99998 0.5C6.99998 0.358122 7.04784 0.239323 7.14357 0.1436C7.23929 0.0478671 7.35809 0 7.49997 0L11.3333 0V3.83333C11.3333 3.97521 11.2854 4.09401 11.1897 4.18973C11.094 4.28546 10.9752 4.33332 10.8333 4.33332C10.6914 4.33332 10.5726 4.28546 10.4769 4.18973C10.3812 4.09401 10.3333 3.97521 10.3333 3.83333V1.70253Z",
    fill: "#909196"
  })
}), xi = () => /* @__PURE__ */ a("svg", {
  fill: "currentColor",
  height: "1em",
  viewBox: "0 0 12 16",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  style: {
    fontSize: "1rem",
    verticalAlign: "-0.175em"
  },
  children: /* @__PURE__ */ a("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd",
    children: /* @__PURE__ */ a("path", {
      d: "M0.832774 15.0323C0.691052 15.0323 0.57233 14.9843 0.476608 14.8885C0.380874 14.7927 0.333008 14.6739 0.333008 14.5323V1.47459C0.333008 1.33293 0.380947 1.21418 0.476824 1.11836C0.572702 1.02253 0.691502 0.974609 0.833225 0.974609C0.974958 0.974609 1.09369 1.02253 1.18941 1.11836C1.28513 1.21418 1.33299 1.33293 1.33299 1.47459V2.33999H10.6663V1.47459C10.6663 1.33293 10.7143 1.21418 10.8101 1.11836C10.906 1.02253 11.0248 0.974609 11.1665 0.974609C11.3083 0.974609 11.427 1.02253 11.5227 1.11836C11.6184 1.21418 11.6663 1.33293 11.6663 1.47459V14.5323C11.6663 14.6739 11.6184 14.7927 11.5225 14.8885C11.4266 14.9843 11.3078 15.0323 11.1661 15.0323C11.0244 15.0323 10.9056 14.9843 10.8099 14.8885C10.7142 14.7927 10.6663 14.6739 10.6663 14.5323V13.6669H1.33299V14.5323C1.33299 14.6739 1.28505 14.7927 1.18917 14.8885C1.09331 14.9843 0.974508 15.0323 0.832774 15.0323ZM1.33299 7.33356H2.87147V5.34638C2.87147 5.17565 2.92922 5.03255 3.04471 4.91706C3.1602 4.80157 3.3033 4.74383 3.47402 4.74383H5.85862C6.02935 4.74383 6.17245 4.80157 6.28794 4.91706C6.40343 5.03255 6.46118 5.17565 6.46118 5.34638V7.33356H10.6663V3.33998H1.33299V7.33356ZM1.33299 12.6669H5.53814V10.6797C5.53814 10.509 5.59589 10.3659 5.71138 10.2504C5.82686 10.1349 5.96997 10.0772 6.14069 10.0772H8.52529C8.69601 10.0772 8.83912 10.1349 8.95461 10.2504C9.0701 10.3659 9.12784 10.509 9.12784 10.6797V12.6669H10.6663V8.33354H1.33299V12.6669ZM3.87144 7.33356H5.46121V5.74379H3.87144V7.33356ZM6.53811 12.6669H8.12788V11.0771H6.53811V12.6669Z",
      fill: "black"
    })
  })
});
var me;
(function(e) {
  e.SHOPPER_BEHAVIOR = "SHOPPER_BEHAVIOR", e.REPORT_BUILDER = "REPORT_BUILDER", e.CHANNEL_INSIGHTS = "CHANNEL_INSIGHTS", e.CUSTOMER_PERCEPTION = "CUSTOMER_PERCEPTION", e.DIGITAL_LANDSCAPES = "DIGITAL_LANDSCAPES", e.INSIGHTS_ACTIVATION = "INSIGHTS_ACTIVATION", e.MODULAR_INTELLIGENCE = "MODULAR_INTELLIGENCE", e.CHANNEL_PERFORMANCE = "CHANNEL_PERFORMANCE";
})(me || (me = {}));
Ce.load({
  "en-US": Ui,
  "es-MX": Gi,
  "fr-CA": Di
});
const ki = {
  href: "/",
  icon: /* @__PURE__ */ mt.createElement(Ke),
  label: "Home",
  isCurrent: !0
}, Hi = {
  [me.SHOPPER_BEHAVIOR]: {
    title: "Shopper Behavior",
    description: "Shopper Behavior content",
    isNewTab: !0,
    icon: Tt,
    trailingHyperlinkIcon: Lt
  },
  [me.REPORT_BUILDER]: {
    title: "Report Builder",
    description: "Examine sales and inventory performance to help you improve strategy and planning",
    icon: Ot
  },
  [me.CHANNEL_INSIGHTS]: {
    title: "Insights",
    description: "Unlock answers to key questions quickly with a full-business view of data that can be personalized to suit your needs",
    icon: rt
  },
  [me.CUSTOMER_PERCEPTION]: {
    title: "Customer Perception",
    description: "Include the customer voice in your decision-making process by connecting with real Walmart shoppers",
    icon: nt
  },
  [me.DIGITAL_LANDSCAPES]: {
    title: "Digital Landscapes",
    description: "Inform your digital strategy with online shopper data from Walmart.com and the Walmart mobile app",
    icon: qe
  },
  [me.INSIGHTS_ACTIVATION]: {
    title: "Insights Activation",
    description: "Identify media activation opportunities informed by real-time shopper insights",
    footer: {
      id: "KHyT9h"
    },
    hideWhenNoAccess: !0,
    icon: Cr
  },
  [me.MODULAR_INTELLIGENCE]: {
    title: "Modular Intelligence",
    description: "Insights and Analysis into modular implementation and state of shelf across stores to improve modular compliance, reduce lost basket opportunities and customer friction",
    icon: xi
  },
  [me.CHANNEL_PERFORMANCE]: {
    title: "Channel Performance",
    description: "",
    icon: qe
  }
};
a(Ke, {}), a(Tt, {}), a(Lt, {}), a(rt, {}), a(nt, {}), a(Ot, {}), a(qe, {}), a(Cr, {});
a(Ke, {}), a(rt, {}), a(nt, {}), a(Ot, {}), a(qe, {});
a(Ke, {}), a(Tt, {}), a(Lt, {}), a(rt, {}), a(nt, {});
const Bi = (e) => {
  const n = e.flatMap((r) => {
    var o;
    const s = {
      code: r.code,
      name: r.name,
      redirectUrl: r.redirectUrl
    }, i = ((o = r.subApps) === null || o === void 0 ? void 0 : o.map((l) => ({
      code: l.code,
      name: l.name,
      redirectUrl: l.redirectUrl
    }))) || [];
    return [
      s,
      ...i
    ];
  }).map((r) => {
    const o = Hi[r.code];
    if (!o)
      return null;
    const s = {
      href: r.redirectUrl || "#",
      icon: o.icon ? mt.createElement(o.icon) : void 0,
      label: o.title
    };
    return o.trailingHyperlinkIcon && (s.trailingHyperlink = {
      icon: mt.createElement(o.trailingHyperlinkIcon)
    }), s;
  }).filter((r) => r !== null);
  return [
    ki,
    ...n
  ];
}, Fi = Pr, Vi = (e) => {
  var { trailingHyperlink: t } = e, n = Xe(e, [
    "trailingHyperlink"
  ]);
  return I(Fi, Object.assign({}, n, {
    children: [
      n.children,
      t && t.icon && a("span", {
        children: t.icon
      })
    ]
  }));
};
function Wi(e) {
  return e.reduce((n, r) => r.isCurrent ? n + 1 : n, 0) <= 1;
}
const $i = ({ sideNavItems: e, userDetails: t }) => {
  const n = t.userInfo, { _: r } = ye(), o = n ? Bi(n.products) : [], s = (e == null ? void 0 : e.length) > 0 ? e : o;
  if (!Wi(s))
    throw new Error("Only one sideNavItem can be set to isCurrent");
  return !s.some((l) => l.isCurrent) && s.length > 0 && (s[0].isCurrent = !0), a("div", {
    className: $e.globalNavSideBar,
    children: t.fetching ? I("div", {
      className: $e.skeletonSection,
      children: [
        a(Re, {
          variant: "rectangle",
          height: 16,
          width: 161
        }),
        a(Re, {
          variant: "rectangle",
          height: 16,
          width: 161
        }),
        a(Re, {
          variant: "rectangle",
          height: 16,
          width: 161
        })
      ]
    }) : a(Mr, {
      children: s.map((l, d) => a(Vi, {
        "data-testid": `sidenav-option-${l == null ? void 0 : l.label}`,
        href: l.href,
        leading: l.icon,
        trailingHyperlink: l.trailingHyperlink,
        isCurrent: l.isCurrent,
        className: `${$e.navItem} ${l.isCurrent ? $e.selected : ""}`,
        children: a("span", {
          children: r(l.label)
        })
      }, d))
    })
  });
}, ji = He($i), zi = JSON.parse('{"YcfUZ9":"Contact Us","rjGI/Q":"Privacy","XYLcNv":"Support","4Y5H+g":"Terms"}'), qi = JSON.parse('{"YcfUZ9":"Contáctenos","rjGI/Q":"Privacidad","XYLcNv":"Soporte","4Y5H+g":"Términos"}'), Yi = JSON.parse('{"YcfUZ9":"Communiquer avec nous","rjGI/Q":"Confidentialité","XYLcNv":"Soutien","4Y5H+g":"Conditions"}');
Ce.load({
  "en-US": zi,
  "es-MX": qi,
  "fr-CA": Yi
});
const Ki = [
  {
    label: {
      id: "rjGI/Q"
    },
    value: "privacy",
    key: "privacy",
    route: "/privacyPolicy",
    allowedDomains: [
      "WMT-US",
      "WMT-CA"
    ]
  },
  {
    label: {
      id: "YcfUZ9"
    },
    value: "contactUs",
    key: "contactUs",
    route: "/contactUs",
    allowedDomains: [
      "WMT-US",
      "WMT-MX",
      "WMT-CA"
    ]
  },
  {
    label: {
      id: "XYLcNv"
    },
    value: "support",
    key: "support",
    route: "/support",
    allowedDomains: [
      "WMT-US",
      "WMT-MX",
      "WMT-CA"
    ]
  },
  {
    label: {
      id: "4Y5H+g"
    },
    value: "terms",
    key: "terms",
    route: "/terms",
    allowedDomains: [
      "WMT-MX"
    ]
  }
], Zi = "Walmart Inc", yr = {
  footerMenuList: Ki,
  copyRightName: Zi
}, Xi = "_container_1trso_1", Ji = "_subContainer_1trso_13", Qi = "_copyRightCaption_1trso_19", el = "_footerList_1trso_26", tl = "_footerListItem_1trso_34", rl = "_footerItemText_1trso_39", Ne = {
  container: Xi,
  subContainer: Ji,
  copyRightCaption: Qi,
  footerList: el,
  footerListItem: tl,
  footerItemText: rl
}, nl = (e) => {
  let t = [
    ...yr.footerMenuList
  ];
  const n = V.getCurrentApplicationHostInfo().currentDomain || h.domains[h.hosts.us];
  if (t = t.filter((r) => r.allowedDomains.includes(n)), e === h.BASIC_VENDOR) {
    const r = t.find((o) => o.key === "support");
    r && (r.route = h.ROUTES.BASIC_USER_KB);
  }
  return t;
}, ol = ({ userContext: e }) => {
  var t;
  const { _: n } = ye(), [r, o] = j(), s = Ze();
  ve(() => {
    var l;
    o(nl((l = e == null ? void 0 : e.tenant) === null || l === void 0 ? void 0 : l.type));
  }, [
    ,
    (t = e == null ? void 0 : e.tenant) === null || t === void 0 ? void 0 : t.type
  ]);
  const i = (l) => {
    Ue.trackEventInfo({
      type: "click",
      actionOn: l.label,
      location: h.locations.footer
    }), s(l.route);
  };
  return I("footer", {
    className: Ne.container,
    children: [
      a("div", {
        className: Ne.subContainer,
        children: a("ul", {
          className: Ne.footerList,
          children: r == null ? void 0 : r.map((l) => a("li", {
            id: l.key,
            "data-testid": l.key,
            className: Ne.footerListItem,
            onClick: () => i(l),
            children: a("span", {
              className: Ne.footerItemText,
              children: n(l.label)
            })
          }, l.key))
        })
      }),
      a("div", {
        className: Ne.subContainer,
        children: I(xe, {
          UNSAFE_className: Ne.copyRightCaption,
          children: [
            "© ",
            (/* @__PURE__ */ new Date()).getFullYear(),
            " ",
            yr.copyRightName
          ]
        })
      })
    ]
  });
}, Cl = He(ol), sl = "_container_6ie2u_1", al = {
  container: sl
}, yl = ({ userInfoResponse: e, resetUserInfo: t, sideNavItems: n, showSideNav: r = !0, onCustomProfileMenuSelection: o, logoLabel: s = h.LOGO_LABEL, title: i, titleProps: l, showLogo: d = !0, isUnAuthenticated: m = !1, logOutCallBack: g, showSupport: C = !0, redirectURL: S = h.ROUTES.APPS, hideBanner: u = !1 }) => {
  var v;
  const [N, A] = j({
    userInfo: e,
    error: {},
    fetching: !0
  }), k = Ur(() => n, [
    n
  ]);
  return ve(() => {
    !e || t && !e || !k || k.length === 0 ? ee(void 0, void 0, void 0, function* () {
      A((w) => Object.assign(Object.assign({}, w), {
        fetching: !0
      }));
      try {
        const w = yield Nt(), E = yield wt(), p = V.mapContextToUserInfoObj(w, E.result);
        A({
          fetching: !1,
          error: {},
          userInfo: p
        });
      } catch (w) {
        A(Object.assign(Object.assign({}, N), {
          fetching: !1,
          error: w || {}
        })), console.log(w);
      }
    }) : A({
      fetching: !1,
      error: {},
      userInfo: e
    });
  }, [
    t,
    e,
    k
  ]), I("div", {
    className: al.container,
    children: [
      a(vi, {
        title: i,
        userDetails: N,
        onCustomProfileMenuSelection: o,
        logoLabel: s,
        titleProps: l,
        showLogo: d,
        isUnAuthenticated: m,
        logOutCallBack: g,
        showSupport: C,
        redirectURL: S,
        hideBanner: u
      }),
      r && ((v = N.userInfo) === null || v === void 0 ? void 0 : v.authz) && a(ji, {
        sideNavItems: n,
        userDetails: N
      })
    ]
  });
};
export {
  _l as Announcement,
  Ha as Banner,
  vl as CustomGroups,
  yl as DVGlobalNav,
  Cl as Footer,
  ji as GlobalNavSideBar,
  vi as Header,
  V as Helper,
  gr as useDataVenturesLanguageService
};
